<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/gaji-periode">Daftar Periode Penggajian</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Daftar Gaji</li>
      </ol>
    </nav>

    <div class="content-block">
      <div class="row" style="padding: 10px">
        <DxButton
          v-if="gajiPeriodeData"
          :text="buttonStatus('text')"
          :type="buttonStatus('type')"
          width="auto"
          height="18px"
          style="float: left"
          styling-mode="filled"
        />
        <div style="width: 20px"></div>
        <DxButton
          v-if="gajiPeriodeData"
          icon="download"
          text="Download File Excel"
          type="default"
          width="auto"
          styling-mode="outlined"
          @click="downloadFileExcel"
        />
      </div>
      <div class="row">
        <h5>
          Daftar Gaji Periode {{ periodeTitle }}
          <span v-if="gajiPeriodeData">
            <DxButton
              v-if="buttonCan('gaji-approve')"
              icon="check"
              @click="approveAllGajiAlert()"
              text="approve semua gaji"
              type="success"
              style="float: right"
              styling-mode="filled"
            ></DxButton>
            <DxButton
              v-if="buttonCan('gaji-approve')"
              icon="refresh"
              @click="requestRevisionAlert()"
              text="Request Revisi Gaji"
              type="danger"
              style="float: right"
              styling-mode="filled"
            ></DxButton>
            <DxButton
              v-if="buttonCan('gaji-create')"
              icon="refresh"
              @click="refreshAllGajiConfirm()"
              text="Hitung ulang seluruh gaji"
              type="danger"
              style="float: right"
              styling-mode="filled"
            ></DxButton>
            <!-- request approval cuma user gaji-create -->
            <DxButton
              v-if="buttonCan('gaji-create')"
              icon="check"
              @click="requestApprovalAlert()"
              text="Request approval"
              type="default"
              style="float: right"
              styling-mode="filled"
            ></DxButton>
          </span>
        </h5>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxButton
          icon="refresh"
          @click="refreshNotif()"
          type="default"
          style="float: right"
          styling-mode="outlined"
        ></DxButton>
        <div class="row row-cols-1 row-cols-md-5 g-4">
          <div class="col">
            <div
              class="card h-100"
              :style="{
                'background-color':
                  'rgba(119, 199, 231, ' + opacityJmlPegawai + ')',
                opacity: opacityJmlPegawai,
              }"
            >
              <div
                class="dashboard-card"
                style="color: black"
                @click="handleClickNotif('')"
              >
                <div class="card-body">
                  <h4
                    class="card-title"
                    style="font-weight: bold; color: aliceblue"
                  >
                    <div v-if="notif">
                      {{ notif["jmlPegawai"] }}
                    </div>
                  </h4>
                  <p
                    class="card-text"
                    style="font-weight: bold; font-size: 16px"
                  >
                    Jumlah Pegawai
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div
              class="card h-100"
              :style="{
                'background-color':
                  'rgba(148, 215, 199, ' + opacityApproved + ')',
                opacity: opacityApproved,
              }"
            >
              <div
                class="dashboard-card"
                style="color: black"
                @click="handleClickNotif('approved')"
              >
                <div class="card-body">
                  <h4
                    class="card-title"
                    style="font-weight: bold; color: aliceblue"
                  >
                    <div v-if="notif">
                      {{ notif["approved"] }}
                    </div>
                  </h4>
                  <p
                    class="card-text"
                    style="font-weight: bold; font-size: 16px"
                  >
                    Gaji Approved
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div
              class="card h-100"
              :style="{
                'background-color': 'rgba(243, 158, 108, ' + opacitySalah + ')',
                opacity: opacitySalah,
              }"
            >
              <div
                class="dashboard-card"
                style="color: black"
                @click="handleClickNotif('salah')"
              >
                <div class="card-body">
                  <h4
                    class="card-title"
                    style="font-weight: bold; color: aliceblue"
                  >
                    <div v-if="notif">
                      {{ notif["salah"] }}
                    </div>
                  </h4>
                  <p
                    class="card-text"
                    style="font-weight: bold; font-size: 16px"
                  >
                    Gaji Salah
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <div>
          <p>
            <strong>DOUBLE CLICK</strong> pada baris tabel untuk menandai gaji
            adalah <strong>SALAH</strong> (hanya dapat dilakukan oleh user
            Pejabat)
          </p>
        </div>
        <DxTabPanel
          id="tabpanel"
          :data-source="tabSource"
          v-model:selected-index="tabPanelIndex"
          :loop="loop"
          :animation-enabled="animationEnabled"
          :swipe-enabled="swipeEnabled"
          item-title-template="title"
          @titleClick="tabTitleClick"
        >
          <template #title="{ data: item }">
            <span class="tab-panel-title">{{ item.text }}</span>
          </template>

          <template #tDireksi>
            <!-- v-if="gajiPeriodeData" -->
            <DxDataGrid
              ref="gridRefDireksi"
              id="gridTDireksi"
              :data-source="gajiStore.dataSourceDireksi"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefDireksi')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              @row-updating="onRowUpdating($event, 'gridRefDireksi')"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              @row-dbl-click="rowDblClick($event)"
              @row-prepared="rowPrepared($event)"
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
            >
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" :apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />

              <DxEditing
                v-if="gajiPeriodeData"
                :allow-updating="allowUpdating()"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />

              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefDireksi')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <!-- <DxSelection mode="multiple" /> -->
              <DxColumnFixing :enabled="true" />

              <DxColumn
                type="buttons"
                :fixed="true"
                fixed-position="right"
                :allow-hiding="false"
              >
                <DxButtonDatagrid name="edit" />

                <DxButtonDatagrid
                  hint="Hitung ulang gaji"
                  icon="refresh"
                  :visible="allowReloadGajiGrid"
                  @click="
                    refreshGajiPerPegawaiConfirm($event, 'gridRefDireksi')
                  "
                  type="danger"
                />
                <DxButtonDatagrid
                  hint="Absen pegawai"
                  icon="event"
                  :visible="true"
                  @click="detailAbsen"
                />
                <DxButtonDatagrid
                  hint="Detail Pegawai"
                  icon="search"
                  :visible="true"
                  @click="detailPegawai"
                />
                <!-- v-if="buttonCan('gaji-update')" -->
                <!-- :visible="can('gaji-update')" -->
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="status_gaji"
                caption="Status Gaji"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'status_gaji')
                "
                min-search-length="3"
                cell-template="statusTemplate"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.statusGajiSource"
                />
              </DxColumn>
              <DxColumn
                :visible="false"
                class="noteditable"
                data-type="boolean"
                data-field="tandai_salah"
                caption="Tandai Salah HALO"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <template #statusTemplate="{ data }">
                <DxButton
                  :icon="formatStatusGaji('icon', { data })"
                  :type="formatStatusGaji('type', { data })"
                  @click="approveClick({ data })"
                />
                <!-- @click="approveClick({ data })" -->
              </template>

              <DxColumn
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />
              <template #currencyTemplate="{ data }">
                {{ formatNumber(data.value) }}
              </template>
              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="pegawai.nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="pegawai.nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <DxColumn
                :allow-filtering="false"
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>

              <DxColumn
                dataField="golongan_id"
                caption="Gol."
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'golongan_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="string"
                data-field="status_ptkp"
                caption="Status PTKP"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="statusPtkpSource"
                  value-expr="nama"
                  display-expr="nama"
                />
              </DxColumn>
              <!-- <DxColumn
                class="noteditable"
                data-field="riwayatGolongan"
                caption="Masa Kerja"
                :calculate-display-value="calculateDisplayMK"
                :calculate-filter-expression="calculateFilterMK"
                :allow-hiding="false"
              >
              </DxColumn> -->
              <DxColumn
                dataField="riwayat_pekerjaan.jabatan_id"
                caption="Jabatan"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'jabatan_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.jabatanSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>

              <DxColumn
                data-type="number"
                dataField="riwayat_pekerjaan.cabang_id"
                caption="Cabang"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'cabang_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.cabangSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.unit_id"
                caption="Unit"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'unit_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.unitSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>

              <DxColumn
                dataField="riwayat_pekerjaan.bagian_id"
                caption="Bagian"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'bagian_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.bagianSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.sub_bagian_id"
                caption="Sub Bagian"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'sub_bagian_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.subBagianSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.bidang_id"
                caption="Bidang"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'bidang_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.bidangSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.sub_bidang_id"
                caption="Sub Bidang"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'sub_bidang_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.subBidangSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.seksi_id"
                caption="Seksi"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'seksi_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.seksiSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn caption="Jabatan PLT">
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.jabatan_id"
                  caption="Jabatan PLT"
                >
                  <DxLookup
                    :data-source="commonStore.jabatanSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.cabang_id"
                  caption="Cabang PLT"
                >
                  <DxLookup
                    :data-source="commonStore.cabangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.unit_id"
                  caption="Unit PLT"
                >
                  <DxLookup
                    :data-source="commonStore.unitSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.bagian_id"
                  caption="Bagian PLT"
                >
                  <DxLookup
                    :data-source="commonStore.bagianSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.sub_bagian_id"
                  caption="Sub Bagian PLT"
                >
                  <DxLookup
                    :data-source="commonStore.subBagianSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.bidang_id"
                  caption="Bidang PLT"
                >
                  <DxLookup
                    :data-source="commonStore.bidangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.sub_bidang_id"
                  caption="Sub Bidang PLT"
                >
                  <DxLookup
                    :data-source="commonStore.subBidangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
              </DxColumn>

              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="gaji_pokok"
                caption="Gaji Pokok"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_perusahaan"
                caption="Tunj. Perusahaan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_jabatan"
                caption="Tunj. Jabatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_kemahalan"
                caption="Tunj. Kemahalan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_air"
                caption="Tunj. Air"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_transport"
                caption="Tunj. Transport"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_pangan"
                caption="Tunj. Pangan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_kesehatan"
                caption="Tunj. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                data-field="absenBulan.tidak_hadir"
                caption="Jml Tdk Hadir"
                class="noteditable"
                :allow-hiding="false"
              />
              <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_5_persen"
                caption="Pot. Tdk Hadir"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="jml_bruto"
                caption="Jml Bruto"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="tun_pph"
                caption="Tunj. PPH"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_kesehatan"
                caption="Pot. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_bpjs_tk_tiga_program"
                caption="Pot. BPJS TK 3 Program"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_bpjs_tk_empat_program"
                caption="Pot. BPJS TK 4 Program"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_pensiun"
                caption="Pot. Pensiun Jiwasraya"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_pph"
                caption="Pot. PPH"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :allow-hiding="false"
                :min-width="150"
              ></DxColumn>
              <DxColumn
                data-type="boolean"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="editedSource"
                  value-expr="val"
                  display-expr="nama"
              /></DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                caption="Terakhir di update oleh"
                cell-template="updatedTemplate"
              >
              </DxColumn>
              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>

              <DxSummary>
                <DxTotalItem
                  column="created_at"
                  summary-type="count"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="gaji_pokok"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_perusahaan"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="tun_jabatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kemahalan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_air"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_transport"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pangan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="absenBulan.tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_tiga_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_empat_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pensiun"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <template #mkTemplate="{ data }">
                {{ formatMasaKerja(data.text) + " tahun" }}
                <!-- {{ data.text }} -->
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>
          <template #tTetap>
            <DxDataGrid
              ref="dataGrid"
              :data-source="gajiStore.dataSourceTetap"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              @editor-preparing="oneditorpreparing"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @exporting="onExporting"
              :focused-row-index="0"
              @editing-start="editingStart"
              @option-changed="onPageChanged($event, 'dataGrid')"
              @row-updating="onRowUpdating($event, 'dataGrid')"
              :word-wrap-enabled="true"
              :height="gridHeight"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
            >
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />
              <DxEditing
                v-if="gajiPeriodeData"
                :allow-updating="allowUpdating()"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />
              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefTetap')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <DxColumnFixing :enabled="true" />
              <DxColumn
                type="buttons"
                :fixed="true"
                fixed-position="right"
                :allow-hiding="false"
              >
                <DxButtonDatagrid name="edit" />
                <DxButtonDatagrid
                  hint="Hitung ulang gaji"
                  icon="refresh"
                  :visible="allowReloadGajiGrid"
                  @click="refreshGajiPerPegawaiConfirm($event, 'gridRefTetap')"
                  type="danger"
                />
                <DxButtonDatagrid
                  hint="Absen pegawai"
                  icon="event"
                  :visible="true"
                  @click="detailAbsen"
                />
                <DxButtonDatagrid
                  hint="Detail Pegawai"
                  icon="search"
                  :visible="true"
                  @click="detailPegawai"
                />
              </DxColumn>

              <DxColumn
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />
              <DxColumn
                class="noteditable"
                data-field="status_gaji"
                caption="Status Gaji"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'status_gaji')
                "
                min-search-length="3"
                cell-template="statusTemplate"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.statusGajiSource"
                />
              </DxColumn>
              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <template #currencyTemplate="{ data }">
                {{ formatNumber(data.value) }}
              </template>
              <template #statusTemplate="{ data }">
                <!-- {{ formatStatusGaji(data.text) }} -->
                <DxButton
                  :icon="formatStatusGaji('icon', { data })"
                  :type="formatStatusGaji('type', { data })"
                  @click="approveClick({ data })"
                />
              </template>

              <!-- <DxColumn
                data-type="number"
                class="noteditable"
                data-field="id"
                caption="GAJIID"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              /> -->

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="pegawai.nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="pegawai.nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <DxColumn
                :allow-filtering="false"
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>

              <DxColumn
                dataField="riwayat_pekerjaan.pegawai_status_id"
                caption="Status"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) =>
                    displayColumnValue($rowData, 'pegawai_status_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.pegawaiStatusSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>

              <DxColumn
                dataField="golongan_id"
                caption="Gol."
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'golongan_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <!-- <DxColumn
                class="noteditable"
                data-field="riwayatGolongan.golongan_id"
                caption="Gol."
              >
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn> -->
              <DxColumn
                data-type="string"
                data-field="status_ptkp"
                caption="Status PTKP"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="statusPtkpSource"
                  value-expr="nama"
                  display-expr="nama"
                />
              </DxColumn>
              <!-- <DxColumn
                class="noteditable"
                data-field="riwayatGolongan"
                caption="Masa Kerja"
                :calculate-display-value="calculateDisplayMK"
                :calculate-filter-expression="calculateFilterMK"
              >
              </DxColumn> -->
              <DxColumn
                dataField="riwayat_pekerjaan.jabatan_id"
                caption="Jabatan"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'jabatan_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.jabatanSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                dataField="riwayat_pekerjaan.cabang_id"
                caption="Cabang"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'cabang_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.cabangSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.unit_id"
                caption="Unit"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'unit_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.unitSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>

              <DxColumn
                dataField="riwayat_pekerjaan.bagian_id"
                caption="Bagian"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'bagian_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.bagianSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.sub_bagian_id"
                caption="Sub Bagian"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'sub_bagian_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.subBagianSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.bidang_id"
                caption="Bidang"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'bidang_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.bidangSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.sub_bidang_id"
                caption="Sub Bidang"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'sub_bidang_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.subBidangSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.seksi_id"
                caption="Seksi"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'seksi_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.seksiSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn caption="Jabatan PLT">
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.jabatan_id"
                  caption="Jabatan PLT"
                >
                  <DxLookup
                    :data-source="commonStore.jabatanSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.cabang_id"
                  caption="Cabang PLT"
                >
                  <DxLookup
                    :data-source="commonStore.cabangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.unit_id"
                  caption="Unit PLT"
                >
                  <DxLookup
                    :data-source="commonStore.unitSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.bagian_id"
                  caption="Bagian PLT"
                >
                  <DxLookup
                    :data-source="commonStore.bagianSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.sub_bagian_id"
                  caption="Sub Bagian PLT"
                >
                  <DxLookup
                    :data-source="commonStore.subBagianSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.bidang_id"
                  caption="Bidang PLT"
                >
                  <DxLookup
                    :data-source="commonStore.bidangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.sub_bidang_id"
                  caption="Sub Bidang PLT"
                >
                  <DxLookup
                    :data-source="commonStore.subBidangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
              </DxColumn>
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="gaji_pokok"
                caption="Gaji Pokok"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_perusahaan"
                caption="Tunj. Perusahaan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_jabatan"
                caption="Tunj. Jabatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_kemahalan"
                caption="Tunj. Kemahalan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_air"
                caption="Tunj. Air"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_transport"
                caption="Tunj. Transport"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_pangan"
                caption="Tunj. Pangan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_kesehatan"
                caption="Tunj. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                data-field="absenBulan.tidak_hadir"
                caption="Jml Tdk Hadir"
                class="noteditable"
                :allow-hiding="false"
              />
              <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_5_persen"
                caption="Pot. Tdk Hadir"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="jml_bruto"
                caption="Jml Bruto"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="tun_pph"
                caption="Tunj. PPH"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_kesehatan"
                caption="Pot. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_bpjs_tk_tiga_program"
                caption="Pot. BPJS TK 3 Program"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_bpjs_tk_empat_program"
                caption="Pot. BPJS TK 4 Program"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_pensiun"
                caption="Pot. Pensiun Jiwasraya"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_pph"
                caption="Pot. PPH"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :min-width="150"
                :allow-hiding="false"
              ></DxColumn>
              <DxColumn
                data-type="boolean"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="editedSource"
                  value-expr="val"
                  display-expr="nama"
              /></DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                caption="Terakhir di update oleh"
                cell-template="updatedTemplate"
              >
              </DxColumn>
              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>

              <DxSummary>
                <DxTotalItem
                  column="created_at"
                  summary-type="count"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="gaji_pokok"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_perusahaan"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="tun_jabatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kemahalan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_air"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_transport"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pangan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="absenBulan.tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <!-- <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                /> -->
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_tiga_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_empat_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pensiun"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <template #mkTemplate="{ data }">
                {{ formatMasaKerja(data.text) + " tahun" }}
                <!-- {{ data.text }} -->
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>
          <template #tHonor>
            <DxDataGrid
              ref="dataGrid"
              :data-source="gajiStore.dataSourceHonor"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              @editor-preparing="oneditorpreparing"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @exporting="onExporting"
              :focused-row-index="0"
              @editing-start="editingStart"
              @option-changed="onPageChanged($event, 'dataGrid')"
              @row-updating="onRowUpdating($event, 'dataGrid')"
              :word-wrap-enabled="true"
              :height="gridHeight"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
            >
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" :apply-filter="currentFilter" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />
              <DxEditing
                v-if="gajiPeriodeData"
                :allow-updating="allowUpdating()"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />

              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefHonor')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <!-- <DxSelection mode="multiple" /> -->
              <DxColumnFixing :enabled="true" />
              <DxColumnFixing :enabled="true" />
              <DxColumn
                type="buttons"
                :fixed="true"
                fixed-position="right"
                :allow-hiding="false"
              >
                <DxButtonDatagrid name="edit" />
                <DxButtonDatagrid
                  hint="Hitung ulang gaji"
                  icon="refresh"
                  :visible="allowReloadGajiGrid"
                  @click="refreshGajiPerPegawaiConfirm($event, 'gridRefHonor')"
                  type="danger"
                />
                <DxButtonDatagrid
                  hint="Absen pegawai"
                  icon="event"
                  :visible="true"
                  @click="detailAbsen"
                />
                <DxButtonDatagrid
                  hint="Detail Pegawai"
                  icon="search"
                  :visible="true"
                  @click="detailPegawai"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="status_gaji"
                caption="Status Gaji"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'status_gaji')
                "
                min-search-length="3"
                cell-template="statusTemplate"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.statusGajiSource"
                />
              </DxColumn>
              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <template #statusTemplate="{ data }">
                <!-- {{ formatStatusGaji(data.text) }} -->
                <DxButton
                  :icon="formatStatusGaji('icon', { data })"
                  :type="formatStatusGaji('type', { data })"
                  @click="approveClick({ data })"
                />
              </template>

              <DxColumn
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />
              <template #currencyTemplate="{ data }">
                {{ formatNumber(data.value) }}
              </template>
              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="pegawai.nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="pegawai.nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <DxColumn
                :allow-filtering="false"
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>

              <DxColumn
                dataField="golongan_id"
                caption="Gol"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'golongan_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.jabatan_id"
                caption="Jabatan"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'jabatan_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.jabatanSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                dataField="riwayat_pekerjaan.cabang_id"
                caption="Cabang"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'cabang_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.cabangSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.unit_id"
                caption="Unit"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'unit_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.unitSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>

              <DxColumn
                dataField="riwayat_pekerjaan.bagian_id"
                caption="Bagian"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'bagian_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.bagianSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.sub_bagian_id"
                caption="Sub Bagian"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'sub_bagian_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.subBagianSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.bidang_id"
                caption="Bidang"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'bidang_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.bidangSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>

              <DxColumn
                dataField="riwayat_pekerjaan.sub_bidang_id"
                caption="Sub Bidang"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'sub_bidang_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.subBidangSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.seksi_id"
                caption="Seksi"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'seksi_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.seksiSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>

              <!-- <DxColumn
                class="noteditableX"
                data-type="number"
                data-field="masa_kerja"
                caption="Masa Kerja"
                cell-template="mkTemplate"
                :allow-hiding="false"
              /> -->

              <DxColumn
                class="noteditable"
                data-field="pegawai.tgl_mulai_bekerja"
                caption="TMT Kontrak"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditableX"
                data-type="number"
                data-field="masa_kerja"
                caption="Masa Kerja"
                cell-template="mkTemplate"
                :allow-hiding="false"
              />

              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="honor_umk_jml"
                caption="Honor (UMK)"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />

              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="kenaikan_masa_kerja"
                caption="Kenaikan Masa Kerja"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_kesehatan"
                caption="Tunj. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                data-field="absenBulan.tidak_hadir"
                caption="Jml Tdk Hadir"
                class="noteditable"
                :allow-hiding="false"
              />

              <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_5_persen"
                caption="Pot. Tdk Hadir"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="jml_bruto"
                caption="Jml Bruto"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_kesehatan"
                caption="Pot. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_bpjs_tk_dua_persen"
                caption="Pot. BPJS TK 2%"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />

              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :allow-hiding="false"
                :min-width="150"
                class="noteditable-ket"
              ></DxColumn>
              <DxColumn
                data-type="boolean"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="editedSource"
                  value-expr="val"
                  display-expr="nama"
              /></DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                caption="Terakhir di update oleh"
                cell-template="updatedTemplate"
              >
              </DxColumn>
              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>
              <!-- <DxColumn
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :allow-hiding="false"
                class="noteditable-ket"
              ></DxColumn> -->

              <DxSummary>
                <DxTotalItem
                  column="created_at"
                  summary-type="count"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="honor_umk_jml"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="kenaikan_masa_kerja"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="absenBulan.tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_dua_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <template #mkTemplate="{ data }">
                <!-- {{ formatMasaKerja(data.text) + " tahun" }} -->
                {{ data.text + " tahun" }}
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>
          <template #tKontrak>
            <DxDataGrid
              ref="dataGrid"
              :data-source="gajiStore.dataSourceKontrak"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              @editor-preparing="oneditorpreparing"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @exporting="onExporting"
              :focused-row-index="0"
              @editing-start="editingStart"
              @option-changed="onPageChanged($event, 'dataGrid')"
              @row-updating="onRowUpdating($event, 'dataGrid')"
              :word-wrap-enabled="true"
              :height="gridHeight"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
            >
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" :apply-filter="currentFilter" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />
              <DxEditing
                v-if="gajiPeriodeData"
                :allow-updating="allowUpdating()"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />
              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefKontrak')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>

              <!-- <DxSelection mode="multiple" /> -->
              <DxColumnFixing :enabled="true" />
              <DxColumn
                type="buttons"
                :fixed="true"
                fixed-position="right"
                :allow-hiding="false"
              >
                <DxButtonDatagrid name="edit" />
                <DxButtonDatagrid
                  hint="Hitung ulang gaji"
                  icon="refresh"
                  :visible="allowReloadGajiGrid"
                  @click="
                    refreshGajiPerPegawaiConfirm($event, 'gridRefKontrak')
                  "
                  type="danger"
                /><DxButtonDatagrid
                  hint="Absen pegawai"
                  icon="event"
                  :visible="true"
                  @click="detailAbsen"
                />
                <DxButtonDatagrid
                  hint="Detail Pegawai"
                  icon="search"
                  :visible="true"
                  @click="detailPegawai"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="status_gaji"
                caption="Status Gaji"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'status_gaji')
                "
                min-search-length="3"
                cell-template="statusTemplate"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.statusGajiSource"
                />
              </DxColumn>
              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <template #statusTemplate="{ data }">
                <!-- {{ formatStatusGaji(data.text) }} -->
                <DxButton
                  :icon="formatStatusGaji('icon', { data })"
                  :type="formatStatusGaji('type', { data })"
                  @click="approveClick({ data })"
                />
              </template>

              <DxColumn
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />
              <template #currencyTemplate="{ data }">
                {{ formatNumber(data.value) }}
              </template>
              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="pegawai.nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="pegawai.nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <DxColumn
                :allow-filtering="false"
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>
              <DxColumn
                dataField="golongan_id"
                caption="Gol"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'golongan_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <!-- <DxColumn
                class="noteditable"
                data-field="riwayatGolongan"
                caption="Masa Kerja"
                :calculate-display-value="calculateDisplayMK"
                :calculate-filter-expression="calculateFilterMK"
                :allow-hiding="false"
              >
              </DxColumn> -->
              <DxColumn
                dataField="riwayat_pekerjaan.jabatan_id"
                caption="Jabatan"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'jabatan_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.jabatanSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>

              <DxColumn
                data-type="number"
                dataField="riwayat_pekerjaan.cabang_id"
                caption="Cabang"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'cabang_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.cabangSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.unit_id"
                caption="Unit"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'unit_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.unitSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>

              <DxColumn
                dataField="riwayat_pekerjaan.bagian_id"
                caption="Bagian"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'bagian_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.bagianSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.sub_bagian_id"
                caption="Sub Bagian"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'sub_bagian_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.subBagianSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.bidang_id"
                caption="Bidang"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'bidang_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.bidangSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>

              <DxColumn
                dataField="riwayat_pekerjaan.sub_bidang_id"
                caption="Sub Bidang"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'sub_bidang_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.subBidangSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>
              <DxColumn
                dataField="riwayat_pekerjaan.seksi_id"
                caption="Seksi"
                :allowHeaderFiltering="false"
                :calculate-display-value="
                  ($rowData) => displayColumnValue($rowData, 'seksi_id')
                "
                min-search-length="3"
              >
                <DxLookup
                  :data-source="commonStore.seksiSource"
                  display-expr="nama"
                  value-expr="id"
                />
              </DxColumn>

              <!-- <DxColumn
                class="noteditableX"
                data-type="number"
                data-field="masa_kerja"
                caption="Masa Kerja"
                cell-template="mkTemplate"
                :allow-hiding="false"
              /> -->

              <DxColumn
                class="noteditable"
                data-field="pegawai.tgl_mulai_bekerja"
                caption="TMT Kontrak"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allow-hiding="false"
              />

              <!-- <DxColumn
                class="noteditable"
                data-field="pegawai.tgl_mulai_bekerja"
                caption="Masa Kerja"
                :calculate-cell-value="calculateCellMK"
                data-type="string"
              ></DxColumn> -->
              <DxColumn
                class="noteditableX"
                data-type="number"
                data-field="masa_kerja"
                caption="Masa Kerja"
                cell-template="mkTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="honor_umk_jml"
                caption="Honor (UMK)"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="kenaikan_masa_kerja"
                caption="Kenaikan Masa Kerja"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_kesehatan"
                caption="Tunj. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                data-field="absenBulan.tidak_hadir"
                caption="Jml Tdk Hadir"
                class="noteditable"
                :allow-hiding="false"
              />
              <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_5_persen"
                caption="Pot. Tdk Hadir"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="tun_bpjs_tk_satu_sembilanbelas_persen"
                caption="Tunj. BPJS TK 1.19%"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="jml_bruto"
                caption="Jml Bruto"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_kesehatan"
                caption="Pot. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_bpjs_tk_satu_sembilanbelas_persen"
                caption="Pot. BPJS TK 1.19%"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />

              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                :min-width="150"
                caption="Catatan"
                :allow-hiding="false"
              ></DxColumn>
              <DxColumn
                data-type="boolean"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="editedSource"
                  value-expr="val"
                  display-expr="nama"
              /></DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                caption="Terakhir di update oleh"
                cell-template="updatedTemplate"
              >
              </DxColumn>
              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>
              <!-- <DxColumn
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :allow-hiding="false"
              ></DxColumn> -->
              <DxSummary>
                <DxTotalItem
                  column="created_at"
                  summary-type="count"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="honor_umk_jml"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="kenaikan_masa_kerja"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="absenBulan.tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_bpjs_tk_satu_sembilanbelas_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_satu_sembilanbelas_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>
              <template #mkTemplate="{ data }">
                <!-- {{ formatMasaKerja(data.text) + " tahun" }} -->
                {{ data.text + " tahun" }}
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>
        </DxTabPanel>
      </div>
      <dx-popup
        :visible="popupLoadingVisible"
        title="Generating gaji..."
        :drag-enabled="false"
        :hide-on-outside-click="false"
        width="300"
        :height="130"
      >
        <div class="d-flex justify-content-center">
          <div
            class="spinner-border"
            style="width: 3rem; height: 3rem"
            role="status"
          ></div>
        </div>
      </dx-popup>
      <DxPopup
        v-if="gajiPeriodeData"
        :visible="popupRefreshAllGajiVisible"
        title="Konfirmasi Setting Penggajian"
        :drag-enabled="false"
        :hide-on-outside-click="false"
        :height="650"
        :width="550"
      >
        <div class="dx-fieldset">
          <div class="dx-field">
            <div class="dx-field-label">Periode Penggajian</div>
            <div class="dx-field-value">
              <DxDateBox
                :disabled="true"
                :show-clear-button="true"
                :use-mask-behavior="true"
                :input-attr="{ 'aria-label': 'Date' }"
                type="date"
                displayFormat="monthAndYear"
                :calendar-options="calendarMonthYear"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.tgl"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxDateBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Skema Gaji Pokok</div>
            <div class="dx-field-value">
              <DxSelectBox
                :dataSource="gajiPokokSkemaSource"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.gaji_pokok_skema_id"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>
        </div>
        <div class="dx-fieldset">
          <div class="dx-fieldset-header">
            Skema penggajian untuk masing-masing status pegawai
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Skema Gaji Direktur Utama</div>
            <div class="dx-field-value">
              <DxSelectBox
                :dataSource="gajiSkemaDirutSource"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.gaji_skema_dirut_id"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Skema Gaji Direktur Umum</div>
            <div class="dx-field-value">
              <DxSelectBox
                :dataSource="gajiSkemaDirumSource"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.gaji_skema_dirum_id"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Skema Gaji Direktur Teknik</div>
            <div class="dx-field-value">
              <DxSelectBox
                :dataSource="gajiSkemaDirtekSource"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.gaji_skema_dirtek_id"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Skema Gaji Pegawai Tetap</div>
            <div class="dx-field-value">
              <DxSelectBox
                :dataSource="gajiSkemaTetapSource"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.gaji_skema_tetap_id"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Skema Gaji Pegawai Capeg</div>
            <div class="dx-field-value">
              <DxSelectBox
                :dataSource="gajiSkemaCapegSource"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.gaji_skema_capeg_id"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Skema Gaji Pekerja Honor</div>
            <div class="dx-field-value">
              <DxSelectBox
                :dataSource="gajiSkemaHonorSource"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.gaji_skema_honor_id"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Skema Gaji Pekerja Kontrak</div>
            <div class="dx-field-value">
              <DxSelectBox
                :dataSource="gajiSkemaKontrakSource"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="gajiPeriodeData.gaji_skema_kontrak_id"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>
        </div>

        <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="before"
          :options="cancelButtonOptions"
        />

        <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          :options="confirmButtonRefreshAllGajiOptions"
        />
      </DxPopup>

      <DxPopup
        :visible="popupWarningVisible"
        :title="popupWarningTitle"
        :drag-enabled="false"
        :hide-on-outside-click="false"
        width="400"
        :height="200"
      >
        <div>
          <p>
            <strong>{{ popupWarningContent }}</strong>
          </p>
        </div>
        <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="before"
          :options="cancelButtonOptions"
        />

        <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          :options="confirmButtonOptionsWarning"
        />
      </DxPopup>
    </div>
  </div>
</template>

<style lang="scss">
.class-tandai-salah {
  background-color: rgba(243, 158, 108);
  /* Other styles as needed */
}
.class-tandai-salah td {
  background-color: rgba(
    243,
    158,
    108,
    0.5
  ); /* Ensures cells also have the background */
}
</style>

<script>
import { useGajiStore } from "@/stores/views/gaji-store";
import { useCommonStore } from "@/stores/utility/common-store";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import * as XLSX from "xlsx";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import DxSelectBox from "devextreme-vue/select-box";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import router from "@/router";
import can from "@/haspermission";
import DxTabPanel from "devextreme-vue/tab-panel";
import DxButton from "devextreme-vue/button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  // DxSelection,
  DxExport,
  DxToolbar,
  DxItem,
  DxSummary,
  DxTotalItem,
  DxButton as DxButtonDatagrid,
  DxColumnChooser,
  DxColumnChooserSearch,
  DxColumnChooserSelection,
  DxPosition,
  DxScrolling,
} from "devextreme-vue/data-grid";
import DxDateBox from "devextreme-vue/date-box";
// import { toHandlerKey } from "vue";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { DateTime } from "luxon";
import _ from "lodash";
import notify from "devextreme/ui/notify";
import axios from "axios";
import auth from "@/auth";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";

import { usePenggajianStatusStore } from "@/stores/PenggajianStatusStore";
import { useGajiPokokSkemaStore } from "@/stores/GajiPokokSkemaStore";
import { useGajiSkemaDirutStore } from "@/stores/GajiSkemaDirutStore";
import { useGajiSkemaDirumStore } from "@/stores/GajiSkemaDirumStore";
import { useGajiSkemaDirtekStore } from "@/stores/GajiSkemaDirtekStore";
import { useGajiSkemaTetapStore } from "@/stores/GajiSkemaTetapStore";
import { useGajiSkemaCapegStore } from "@/stores/GajiSkemaCapegStore";
import { useGajiSkemaHonorStore } from "@/stores/GajiSkemaHonorStore";
import { useGajiSkemaKontrakStore } from "@/stores/GajiSkemaKontrakStore";

const tabSource = [
  {
    id: 1,
    text: "Direksi",
    template: "tDireksi",
  },
  {
    id: 2,
    text: "Pegawai Tetap",
    template: "tTetap",
  },
  {
    id: 3,
    text: "Pekerja Honor",
    template: "tHonor",
  },
  {
    id: 4,
    text: "Pekerja Kontrak",
    template: "tKontrak",
  },
];

export default {
  components: {
    DxScrolling,
    DxTabPanel,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxLookup,
    DxPager,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxItem,
    DxSummary,
    DxTotalItem,
    DxButton,
    DxButtonDatagrid,
    DxColumnChooser,
    DxColumnChooserSearch,
    DxColumnChooserSelection,
    DxPosition,
    DxPopup,
    DxToolbarItem,
    DxSelectBox,
    DxDateBox,
    DxValidator,
    DxRequiredRule,

    // confirm,
  },
  setup() {
    const gajiStore = useGajiStore();

    const gajiStatusStore = usePenggajianStatusStore();
    const gajiPokokSkemaStore = useGajiPokokSkemaStore();
    const gajiSkemaDirutStore = useGajiSkemaDirutStore();
    const gajiSkemaDirumStore = useGajiSkemaDirumStore();
    const gajiSkemaDirtekStore = useGajiSkemaDirtekStore();
    const gajiSkemaTetapStore = useGajiSkemaTetapStore();
    const gajiSkemaCapegStore = useGajiSkemaCapegStore();
    const gajiSkemaHonorStore = useGajiSkemaHonorStore();
    const gajiSkemaKontrakStore = useGajiSkemaKontrakStore();

    const commonStore = useCommonStore();
    return {
      commonStore,
      gajiStore,

      gajiStatusStore,
      gajiPokokSkemaStore,
      gajiSkemaDirutStore,
      gajiSkemaDirumStore,
      gajiSkemaDirtekStore,
      gajiSkemaTetapStore,
      gajiSkemaCapegStore,
      gajiSkemaHonorStore,
      gajiSkemaKontrakStore,
    };
  },

  data() {
    return {
      statusGajiSource: [
        { val: true, nama: "Approved" },
        { val: false, nama: "Belum Approved" },
      ],

      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",
      pejabatDirum: null,
      pejabatKabagUmum: null,
      pejabatKasubagPersonalia: null,
      rowClickData: null,
      rowClickRef: null,
      pegawaiIdClick: null,
      gajiPokokSkemaSource: null,
      gajiSkemaDirutSource: null,
      gajiSkemaDirumSource: null,
      gajiSkemaDirtekSource: null,

      gajiSkemaTetapSource: null,
      gajiSkemaCapegSource: null,
      gajiSkemaHonorSource: null,
      gajiSkemaKontrakSource: null,
      calendarMonthYear: {
        maxZoomLevel: "year",
        minZoomLevel: "century",
      },
      gajiStatusSource: null,
      popupWarningVisible: false,
      popupWarningContent: null,
      popupWarningTitle: null,
      opacitySalah: 1, // Initial opacity value
      opacityApproved: 1, // Initial opacity value
      opacityJmlPegawai: 1, // Initial opacity value
      notif: [],
      gajiPeriodeId: this.$route.query.id,
      gajiPeriodeData: null,
      periodeTitle: null,
      mode: "select",
      searchEnabled: true,
      allowSelectAll: true,
      selectByClick: true,
      recursive: true,
      editorOptions: { placeholder: "Search column" },

      router: router,
      statusButtonIcon: null,
      statusButtonType: null,
      numberingPageSize: 50,
      numberingPageNumber: 0,
      dataSourceTetap: null,
      dataSourceHonor: null,
      dataSourceKontrak: null,
      dataSourceDireksi: null,
      tabPanelIndex: 0,
      loop: false,
      animationEnabled: true,
      swipeEnabled: false,
      tabSource: tabSource,
      popupRefreshAllGajiVisible: false,
      popupLoadingVisible: false,
      editedSource: [
        { val: true, nama: "Diedit user" },
        { val: false, nama: "Dibuat sistem" },
      ],
      statusPtkpSource: [
        { nama: "" },
        { nama: "TK" },
        { nama: "K0" },
        { nama: "K1" },
        { nama: "K2" },
        { nama: "K3" },
      ],

      filterValue: [],

      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      calculateFilterMK: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        if (selectedFilterOperation === "contains" && target == "filterRow") {
          const currentDate = DateTime.now();
          const mkDate = currentDate.minus({ years: filterValue });
          var filterExpression = [
            "year(" +
              this.dataField +
              ") ge " +
              mkDate.year +
              " and " +
              "year(" +
              this.dataField +
              ") le " +
              currentDate.year,
          ];

          return filterExpression;
        }
      },
      filterOperations: ["=", "<>", ">", "<", "between"],
      calculateFilterExpression: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        let column = this;
        if (selectedFilterOperation === "=" && target == "filterRow") {
          let bulan = filterValue.getMonth() + 1;
          var filterExpression = [
            "month(" +
              column.dataField +
              ") eq " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterRow") {
          //notequal
          let bulan = filterValue.getMonth() + 1;
          var filterExpression2 = [
            "month(" +
              column.dataField +
              ") ne " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") ne " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression2;
        }
        if (selectedFilterOperation === "<" && target == "filterRow") {
          //less than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression3 = [
            "year(" +
              column.dataField +
              ") lt " +
              filterValue.getFullYear().toString() +
              " or (year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString() +
              " and month(" +
              column.dataField +
              ") lt " +
              bulan +
              ")",
          ];
          return filterExpression3;
        }
        if (selectedFilterOperation === ">" && target == "filterRow") {
          //greater than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression4 = [
            "year(" +
              column.dataField +
              ") gt " +
              filterValue.getFullYear().toString() +
              " or (year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString() +
              " and month(" +
              column.dataField +
              ") gt " +
              bulan +
              ")",
          ];
          return filterExpression4;
        }

        if (selectedFilterOperation === "between" && target == "filterRow") {
          // (year(Date) eq 2022 and month(Date) ge 5) or (year(Date) eq 2023 and month(Date) le 6)
          let bulan1 = filterValue[0].getMonth() + 1;
          let bulan2 = filterValue[1].getMonth() + 1;

          var filterExpression5 = [
            "month(" +
              column.dataField +
              ") ge " +
              bulan1 +
              " and year(" +
              column.dataField +
              ") ge " +
              filterValue[0].getFullYear() +
              " and " +
              "month(" +
              column.dataField +
              ") le " +
              bulan2 +
              " and year(" +
              column.dataField +
              ") le " +
              filterValue[1].getFullYear(),
          ];
          return filterExpression5;
        }

        // Invokes the default filtering behavior
        return column.defaultCalculateFilterExpression(arguments);
      },

      cancelButtonOptions: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popupWarningVisible = false;
          this.popupRefreshAllGajiVisible = false;
        },
      },
      // popupWarningClicked: null,
      popupWarningStatusId: null,
      confirmButtonRefreshAllGajiOptions: {
        text: "Hitung Ulang Seluruh Gaji",
        onClick: () => {
          // this.popupRefreshAllGajiVisible = false; sementara disable
          this.refreshAllGaji();
        },
      },
      confirmButtonOptionsWarning: {
        text: "Confirm",
        onClick: () => {
          this.popupWarningVisible = false;
          if (this.popupWarningStatusId === "refreshAllGajiConfirm") {
            this.popupRefreshAllGajiVisible = true;

            return;
          }
          if (this.popupWarningStatusId === "refreshGajiPerPegawaiConfirm") {
            this.refreshGajiPerPegawai();
            return;
          }

          if (this.popupWarningStatusId === 3) {
            const updatedData = {
              status_gaji: true,
              tandai_salah: false,
              gaji_periode_id: this.gajiPeriodeId,
            };
            this.sinkronAllGaji(updatedData);
          }
          this.updateStatusGajiPeriode(this.popupWarningStatusId);
          // if (typeof this[this.popupWarningClicked] === "function")
          //   this[this.popupWarningClicked]();
        },
      },
    };
  },
  async mounted() {
    await this.fetchDataPejabatPembuatGaji();
    this.gajiStatusSource = await this.gajiStatusStore.get();
    this.notif = await this.fetchDataNotif();
    this.gajiPeriodeData = await this.fetchDataPeriode();
    this.gajiPokokSkemaSource = await this.gajiPokokSkemaStore.get();
    this.gajiSkemaDirutSource = await this.gajiSkemaDirutStore.get();
    this.gajiSkemaDirumSource = await this.gajiSkemaDirumStore.get();
    this.gajiSkemaDirtekSource = await this.gajiSkemaDirtekStore.get();
    this.gajiSkemaTetapSource = await this.gajiSkemaTetapStore.get();
    this.gajiSkemaCapegSource = await this.gajiSkemaCapegStore.get();
    this.gajiSkemaHonorSource = await this.gajiSkemaHonorStore.get();
    this.gajiSkemaKontrakSource = await this.gajiSkemaKontrakStore.get();

    this.periodeTitle = this.formatMonthTitle(this.$route.query.tgl);
    document.title = "Daftar Gaji Periode " + this.periodeTitle;
  },
  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },
  methods: {
    displayColumnValue(e, column) {
      let res = null;
      if (column === "jabatan_id")
        res = _.find(this.commonStore.jabatanStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      else if (column === "cabang_id")
        res = _.find(this.commonStore.cabangStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      else if (column === "unit_id")
        res = _.find(this.commonStore.unitStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      else if (column === "pegawai_status_id")
        res = _.find(this.commonStore.pegawaiStatusStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      else if (column === "bagian_id")
        res = _.find(this.commonStore.bagianStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      else if (column === "sub_bagian_id")
        res = _.find(this.commonStore.subBagianStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      else if (column === "bidang_id")
        res = _.find(this.commonStore.bidangStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      else if (column === "sub_bidang_id")
        res = _.find(this.commonStore.subBidangStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      else if (column === "seksi_id")
        res = _.find(this.commonStore.seksiStore, (item) => {
          return _.get(item, "id") === e.riwayat_pekerjaan[column];
        });
      else if (column === "golongan_id")
        res = _.find(this.commonStore.golonganStore, (item) => {
          return _.get(item, "id") === e[column];
        });
      else if (column === "status_gaji")
        res = _.find(this.commonStore.statusGajiStore, (item) => {
          return _.get(item, "val") === e[column];
        });

      if (res) return res.nama;
      return "";
    },
    async fetchDataPejabatPembuatGaji() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };

      const response = await axios.get(`${API_BASE_URL}/pejabat_gaji`, config);
      this.pejabatDirum = response.data.dirum.simpeg_pegawai.nama;
      this.pejabatKabagUmum = response.data.kabagUmum.simpeg_pegawai.nama;
      this.pejabatKasubagPersonalia =
        response.data.kasubagPersonalia.simpeg_pegawai.nama;
    },

    prepare_data_excel(data, cari, cariValue, unitId = null, orderBy = null) {
      var temp = null;
      if (unitId === null) {
        temp = _.filter(data, (item) => {
          return _.get(item, cari) === cariValue;
        });
      } else {
        temp = _.filter(data, (item) => {
          return (
            _.get(item, cari) === cariValue &&
            _.get(item, "riwayat_pekerjaan.unit_id") === unitId
          );
        });
      }

      // return _.orderBy(
      //   temp,
      //   [(item) => _.get(item, "riwayat_pekerjaan.jabatan_id")],
      //   ["asc"]
      // );
      if (orderBy !== null)
        return _.orderBy(temp, [(item) => _.get(item, orderBy)], ["asc"]);
      else
        return _.orderBy(
          temp,
          [
            (item) => _.get(item, "riwayat_pekerjaan.jabatan_id"),
            (item) => _.get(item, "pegawai.nik"),
          ],
          ["asc", "asc"]
        );
    },
    prepare_data_bagians(bagianId) {
      var tempBagian = _.filter(this.commonStore.bagianStore, (item) => {
        return _.get(item, "id") === bagianId;
      });
      var tempSubBagian = _.filter(this.commonStore.subBagianStore, (item) => {
        return _.get(item, "bagian_id") === bagianId;
      });
      return _.concat(tempBagian, tempSubBagian);
    },

    prepare_data_seksi(cabangData, cabangId, unitId = null) {
      //cabangData sudah difilter berdasarkan cabang n unit
      const seksiIds = _.uniq(_.map(cabangData, "riwayat_pekerjaan.seksi_id"));
      const tempSeksi = _.filter(this.commonStore.seksiStore, (obj) =>
        seksiIds.includes(obj.id)
      );
      var tempCabang = null;
      if (unitId === null)
        tempCabang = _.filter(this.commonStore.cabangStore, (item) => {
          return _.get(item, "id") === cabangId;
        });
      else {
        tempCabang = _.filter(this.commonStore.unitStore, (item) => {
          return _.get(item, "id") === unitId;
        });
      }

      return _.concat(tempCabang, tempSeksi);
    },

    prepare_data_bidangs(bidangId) {
      var tempBidang = _.filter(this.commonStore.bidangStore, (item) => {
        return _.get(item, "id") === bidangId;
      });
      var tempSubBidang = _.filter(this.commonStore.subBidangStore, (item) => {
        return _.get(item, "bidang_id") === bidangId;
      });
      return _.concat(tempBidang, tempSubBidang);
    },

    prepare_data_pemimpin(data) {
      var temp = _.filter(data, (item) => {
        const jabatanId = _.get(item, "riwayat_pekerjaan.jabatan_id");
        return (
          _.inRange(jabatanId, 4, 7) ||
          _.get(item, "riwayat_pekerjaan.jabatan_id") === 9
        ); // 7 is exclusive, so it checks for values between 4 and 6
      }); //9 = kaunit
      return temp;
    },

    prepare_data_staf(data) {
      // var temp = _.filter(data, (item) => {
      //   const jabatanId = _.get(item, "riwayat_pekerjaan.jabatan_id");
      //   return (
      //     !_.inRange(jabatanId, 4, 7) &&
      //     !_.get(item, "riwayat_pekerjaan.jabatan_id") === 9
      //   ); // 7 is exclusive, so it checks for values between 4 and 6
      // });
      var temp = _.filter(data, (item) => {
        const jabatanId = _.get(item, "riwayat_pekerjaan.jabatan_id");
        return !([4, 5, 6].includes(jabatanId) || jabatanId === 9);
      });

      return temp;
    },

    async downloadFileExcel() {
      this.popupLoadingVisible = true;
      const dataTetapCapeg = await this.fetchGaji(this.gajiPeriodeId, 2, 3);
      const dataHonor = await this.fetchGaji(this.gajiPeriodeId, 4);
      const dataKontrak = await this.fetchGaji(this.gajiPeriodeId, 5);
      this.popupLoadingVisible = false;
      const dataBagianUmum = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.bagian_id",
        1
      );

      const dataDireksi = await this.fetchGaji(this.gajiPeriodeId, 1);
      const dataBagianSPI = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.bidang_id",
        1
      );

      const dataBagianLitbang = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.bidang_id",
        2
      );

      const dataBagianKeuangan = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.bagian_id",
        2
      );
      const dataBagianPelayanan = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.bagian_id",
        3
      );
      const dataBagianPerencana = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.bagian_id",
        4
      );
      const dataBagianProduksi = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.bagian_id",
        5
      );
      const dataBagianDistribusi = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.bagian_id",
        6
      );

      const workbook = XLSX.utils.book_new();
      const sheetName = "ADMINISTRASI";
      XLSX.utils.book_append_sheet(workbook, {}, sheetName);
      const sheetNameHonor = "TENAGA HONOR";
      const sheetNameKontrak = "TENAGA KONTRAK";
      XLSX.utils.book_append_sheet(workbook, {}, sheetNameHonor);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNameKontrak);
      var row = 3;
      var numbering = 0;

      //KONTRAK - PUSAT
      const dataKontrakPusat = this.prepare_data_excel(
        dataKontrak,
        "riwayat_pekerjaan.cabang_id",
        1,
        null,
        "riwayat_pekerjaan.tgl_mulai_bekerja"
      );
      row = this.wbAddHeaderHonor(
        workbook,
        sheetNameKontrak,
        row,
        "HONORARIUM TENAGA KONTRAK KANTOR PUSAT",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
        "pusat"
      ); //status pegawai/bulan/cabang
      row = this.wbAddHeaderKomponenKontrak(workbook, sheetNameKontrak, row); //nama, no, golongan

      row = this.wbAddContentKontrak(
        workbook,
        sheetNameKontrak,
        row,
        numbering,
        dataKontrakPusat
      );
      row = this.wbAddContentKontrakFooter(
        workbook,
        sheetNameKontrak,
        row,
        dataKontrakPusat
      );
      numbering = numbering + dataKontrakPusat.length;
      //END KONTRAK PUSAT

      //KONTRAK - KUBUTAMBAHAN
      const dataKontrakKubutambahan = this.prepare_data_excel(
        dataKontrak,
        "riwayat_pekerjaan.cabang_id",
        6,
        null,
        "riwayat_pekerjaan.tgl_mulai_bekerja"
      );
      if (dataKontrakKubutambahan.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameKontrak,
          row,
          "HONORARIUM TENAGA KONTRAK KANTOR CABANG KUBUTAMBAHAN",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenKontrak(workbook, sheetNameKontrak, row); //nama, no, golongan

        row = this.wbAddContentKontrak(
          workbook,
          sheetNameKontrak,
          row,
          numbering,
          dataKontrakKubutambahan
        );
        row = this.wbAddContentKontrakFooter(
          workbook,
          sheetNameKontrak,
          row,
          dataKontrakKubutambahan
        );
      }
      numbering = numbering + dataKontrakKubutambahan.length;
      //END OF KONTRAK KUBUTAMBAHAN

      //KONTRAK - LOVINA
      const dataKontrakLovina = this.prepare_data_excel(
        dataKontrak,
        "riwayat_pekerjaan.cabang_id",
        5,
        null,
        "riwayat_pekerjaan.tgl_mulai_bekerja"
      );

      if (dataKontrakLovina.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameKontrak,
          row,
          "HONORARIUM TENAGA KONTRAK KANTOR CABANG LOVINA",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenKontrak(workbook, sheetNameKontrak, row); //nama, no, golongan

        row = this.wbAddContentKontrak(
          workbook,
          sheetNameKontrak,
          row,
          numbering,
          dataKontrakLovina
        );
        row = this.wbAddContentKontrakFooter(
          workbook,
          sheetNameKontrak,
          row,
          dataKontrakLovina
        );
      }
      numbering = numbering + dataKontrakLovina.length;
      //END OF KONTRAK LOVINA

      //KONTRAK - SERIRIT
      const dataKontrakSeririt = this.prepare_data_excel(
        dataKontrak,
        "riwayat_pekerjaan.cabang_id",
        4,
        null,
        "riwayat_pekerjaan.tgl_mulai_bekerja"
      );

      if (dataKontrakSeririt.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameKontrak,
          row,
          "HONORARIUM TENAGA KONTRAK KANTOR CABANG SERIRIT",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenKontrak(workbook, sheetNameKontrak, row); //nama, no, golongan

        row = this.wbAddContentKontrak(
          workbook,
          sheetNameKontrak,
          row,
          numbering,
          dataKontrakSeririt
        );
        row = this.wbAddContentKontrakFooter(
          workbook,
          sheetNameKontrak,
          row,
          dataKontrakSeririt
        );
      }
      numbering = numbering + dataKontrakSeririt.length;
      //END OF KONTRAK SERIRIT

      //KONTRAK - GEROKGAK
      const dataKontrakGerokgak = this.prepare_data_excel(
        dataKontrak,
        "riwayat_pekerjaan.cabang_id",
        2,
        null,
        "riwayat_pekerjaan.tgl_mulai_bekerja"
      );

      if (dataKontrakGerokgak.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameKontrak,
          row,
          "HONORARIUM TENAGA KONTRAK KANTOR CABANG GEROKGAK",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenKontrak(workbook, sheetNameKontrak, row); //nama, no, golongan

        row = this.wbAddContentKontrak(
          workbook,
          sheetNameKontrak,
          row,
          numbering,
          dataKontrakGerokgak
        );
        row = this.wbAddContentKontrakFooter(
          workbook,
          sheetNameKontrak,
          row,
          dataKontrakGerokgak
        );
      }
      numbering = numbering + dataKontrakGerokgak.length;
      //END OF KONTRAK GEROKGAK

      //KONTRAK - BUSUNGBIU
      const dataKontrakBusungbiu = this.prepare_data_excel(
        dataKontrak,
        "riwayat_pekerjaan.cabang_id",
        3,
        null,
        "riwayat_pekerjaan.tgl_mulai_bekerja"
      );

      if (dataKontrakBusungbiu.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameKontrak,
          row,
          "HONORARIUM TENAGA KONTRAK KANTOR CABANG BUSUNGBIU",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenKontrak(workbook, sheetNameKontrak, row); //nama, no, golongan

        row = this.wbAddContentKontrak(
          workbook,
          sheetNameKontrak,
          row,
          numbering,
          dataKontrakBusungbiu
        );
        row = this.wbAddContentKontrakFooter(
          workbook,
          sheetNameKontrak,
          row,
          dataKontrakBusungbiu
        );
      }
      numbering = numbering + dataKontrakBusungbiu.length;
      //END OF KONTRAK BUSUNGBIU
      row = this.wbAddContentKontrakFooterTerbilang(
        workbook,
        sheetNameKontrak,
        row,
        dataKontrak
      );

      // XLSX.writeFile(workbook, "testing export gaji.xlsx");
      // return;

      //=========================================================================================================

      //HONOR - PUSAT
      row = 3;
      numbering = 0;
      const dataHonorPusat = this.prepare_data_excel(
        dataHonor,
        "riwayat_pekerjaan.cabang_id",
        1,
        null,
        "riwayat_pekerjaan.tgl_mulai_bekerja"
      );
      row = this.wbAddHeaderHonor(
        workbook,
        sheetNameHonor,
        row,
        "HONORARIUM TENAGA HONORAIR KANTOR PUSAT",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase(),
        "pusat"
      ); //status pegawai/bulan/cabang
      row = this.wbAddHeaderKomponenHonor(workbook, sheetNameHonor, row); //nama, no, golongan

      row = this.wbAddContentHonor(
        workbook,
        sheetNameHonor,
        row,
        numbering,
        dataHonorPusat
      );
      row = this.wbAddContentHonorFooter(
        workbook,
        sheetNameHonor,
        row,
        dataHonorPusat
      );
      numbering = numbering + dataHonorPusat.length;
      //END OF HONOR PUSAT

      //HONOR - KUBUTAMBAHAN
      const dataHonorKubutambahan = this.prepare_data_excel(
        dataHonor,
        "riwayat_pekerjaan.cabang_id",
        6,
        null,
        "riwayat_pekerjaan.tgl_mulai_bekerja"
      );
      if (dataHonorKubutambahan.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameHonor,
          row,
          "HONORARIUM TENAGA HONORAIR KANTOR CABANG KUBUTAMBAHAN",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenHonor(workbook, sheetNameHonor, row); //nama, no, golongan

        row = this.wbAddContentHonor(
          workbook,
          sheetNameHonor,
          row,
          numbering,
          dataHonorKubutambahan
        );
        row = this.wbAddContentHonorFooter(
          workbook,
          sheetNameHonor,
          row,
          dataHonorKubutambahan
        );
      }
      numbering = numbering + dataHonorKubutambahan.length;
      //END OF HONOR KUBUTAMBAHAN

      //HONOR - LOVINA
      const dataHonorLovina = this.prepare_data_excel(
        dataHonor,
        "riwayat_pekerjaan.cabang_id",
        5,
        null,
        "riwayat_pekerjaan.tgl_mulai_bekerja"
      );
      if (dataHonorLovina.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameHonor,
          row,
          "HONORARIUM TENAGA HONORAIR KANTOR CABANG LOVINA",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenHonor(workbook, sheetNameHonor, row); //nama, no, golongan

        row = this.wbAddContentHonor(
          workbook,
          sheetNameHonor,
          row,
          numbering,
          dataHonorLovina
        );
        row = this.wbAddContentHonorFooter(
          workbook,
          sheetNameHonor,
          row,
          dataHonorLovina
        );
      }
      numbering = numbering + dataHonorLovina.length;
      //END OF HONOR LOVINA

      //HONOR - SERIRIT
      const dataHonorSeririt = this.prepare_data_excel(
        dataHonor,
        "riwayat_pekerjaan.cabang_id",
        4,
        null,
        "riwayat_pekerjaan.tgl_mulai_bekerja"
      );
      if (dataHonorSeririt.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameHonor,
          row,
          "HONORARIUM TENAGA HONORAIR KANTOR CABANG SERIRIT",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenHonor(workbook, sheetNameHonor, row); //nama, no, golongan

        row = this.wbAddContentHonor(
          workbook,
          sheetNameHonor,
          row,
          numbering,
          dataHonorSeririt
        );
        row = this.wbAddContentHonorFooter(
          workbook,
          sheetNameHonor,
          row,
          dataHonorSeririt
        );
      }
      numbering = numbering + dataHonorSeririt.length;
      //END OF HONOR SERIRIT

      //HONOR - GEROKGAK
      const dataHonorGerokgak = this.prepare_data_excel(
        dataHonor,
        "riwayat_pekerjaan.cabang_id",
        2,
        null,
        "riwayat_pekerjaan.tgl_mulai_bekerja"
      );
      if (dataHonorGerokgak.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameHonor,
          row,
          "HONORARIUM TENAGA HONORAIR KANTOR CABANG GEROKGAK",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenHonor(workbook, sheetNameHonor, row); //nama, no, golongan

        row = this.wbAddContentHonor(
          workbook,
          sheetNameHonor,
          row,
          numbering,
          dataHonorGerokgak
        );
        row = this.wbAddContentHonorFooter(
          workbook,
          sheetNameHonor,
          row,
          dataHonorGerokgak
        );
      }
      numbering = numbering + dataHonorGerokgak.length;
      //END OF HONOR GEROKGAK

      //HONOR - BUSUNGBIU
      const dataHonorBusungbiu = this.prepare_data_excel(
        dataHonor,
        "riwayat_pekerjaan.cabang_id",
        3,
        null,
        "riwayat_pekerjaan.tgl_mulai_bekerja"
      );
      if (dataHonorBusungbiu.length > 0) {
        row = this.wbAddHeaderHonor(
          workbook,
          sheetNameHonor,
          row,
          "HONORARIUM TENAGA HONORAIR KANTOR CABANG BUSUNGBIU",
          "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
        ); //status pegawai/bulan/cabang
        row = this.wbAddHeaderKomponenHonor(workbook, sheetNameHonor, row); //nama, no, golongan

        row = this.wbAddContentHonor(
          workbook,
          sheetNameHonor,
          row,
          numbering,
          dataHonorBusungbiu
        );
        row = this.wbAddContentHonorFooter(
          workbook,
          sheetNameHonor,
          row,
          dataHonorBusungbiu
        );
      }
      numbering = numbering + dataHonorBusungbiu.length;
      //END OF HONOR BUSUNGBIU

      row = this.wbAddContentHonorFooterTerbilang(
        workbook,
        sheetNameHonor,
        row,
        dataHonor
      );
      // XLSX.writeFile(workbook, "testing export gaji.xlsx");
      // return;
      //========================================================================================================
      /////MULAI SHEET ADMINISTRASI PEGAWAI TETAP PUSAT DAN CABANG
      row = 3;
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN DIREKSI",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
      ); //status pegawai/bulan/cabang
      //direksi
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      row = this.wbAddContentTetap(workbook, sheetName, row, dataDireksi); //isi data
      row = row + 10;

      //TETAP - SPI
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN SATUAN PENGAWAS INTERN",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      var bagianTitle = this.prepare_data_bidangs(1);

      var bagianPemimpin = this.prepare_data_pemimpin(dataBagianSPI);
      var bagianStaf = this.prepare_data_staf(dataBagianSPI);
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.sub_bidang_id"
      ); //isi data

      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataBagianSPI
      );
      row = row + 15;
      //END TETAP SPI

      //TETAP - UMUM
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN BAGIAN UMUM",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      bagianTitle = this.prepare_data_bagians(1);
      bagianPemimpin = this.prepare_data_pemimpin(dataBagianUmum);
      bagianStaf = this.prepare_data_staf(dataBagianUmum);
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.sub_bagian_id"
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataBagianUmum
      );
      row = row + 15;
      //END TETAP UMUM

      //TETAP - KEUANGAN
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN BAGIAN KEUANGAN",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      bagianTitle = this.prepare_data_bagians(2);
      bagianPemimpin = this.prepare_data_pemimpin(dataBagianKeuangan);
      bagianStaf = this.prepare_data_staf(dataBagianKeuangan);
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.sub_bagian_id"
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataBagianKeuangan
      );
      row = row + 15;
      //END TETAP KEUANGAN

      //TETAP - PELAYANAN
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN BAGIAN PELAYANAN",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      bagianTitle = this.prepare_data_bagians(3);
      bagianPemimpin = this.prepare_data_pemimpin(dataBagianPelayanan);
      bagianStaf = this.prepare_data_staf(dataBagianPelayanan);
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.sub_bagian_id"
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataBagianPelayanan
      );
      row = row + 15;
      //END TETAP PELAYANAN

      //TETAP - PERANCANA TEKNIK
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN BAGIAN PERANCANA TEKNIK",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      bagianTitle = this.prepare_data_bagians(4);
      bagianPemimpin = this.prepare_data_pemimpin(dataBagianPerencana);
      bagianStaf = this.prepare_data_staf(dataBagianPerencana);
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.sub_bagian_id"
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataBagianPerencana
      );
      row = row + 15;
      //END TETAP PERANCANA TEKNIK

      //TETAP - PPRODUKSI
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN BAGIAN PRODUKSI",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      bagianTitle = this.prepare_data_bagians(5);
      bagianPemimpin = this.prepare_data_pemimpin(dataBagianProduksi);
      bagianStaf = this.prepare_data_staf(dataBagianProduksi);
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.sub_bagian_id"
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataBagianProduksi
      );
      row = row + 15;
      //END TETAP PRODUKSI

      //TETAP - DISTRIBUSI
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN BAGIAN DISTRIBUSI",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      bagianTitle = this.prepare_data_bagians(6);
      bagianPemimpin = this.prepare_data_pemimpin(dataBagianDistribusi);
      bagianStaf = this.prepare_data_staf(dataBagianDistribusi);
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.sub_bagian_id"
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataBagianDistribusi
      );
      row = row + 15;
      //END TETAP DISTRIBUSI

      //TETAP - LITBANG
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN LITBANG",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      bagianTitle = this.prepare_data_bidangs(2);

      bagianPemimpin = this.prepare_data_pemimpin(dataBagianLitbang);
      bagianStaf = this.prepare_data_staf(dataBagianLitbang);
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.sub_bidang_id"
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataBagianLitbang
      );
      row = row + 15;
      //END TETAP LITBANG

      //****CABANG KUBUTAMBAHAN  */
      const dataCabangKubutambahan = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.cabang_id",
        6
      );
      bagianTitle = this.prepare_data_seksi(dataCabangKubutambahan, 6);
      bagianPemimpin = this.prepare_data_pemimpin(dataCabangKubutambahan); //cari id kacab
      bagianStaf = this.prepare_data_staf(dataCabangKubutambahan);

      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN",
        "CABANG KUBUTAMBAHAN",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.seksi_id"
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataCabangKubutambahan
      );
      row = row + 15;
      //END CABANG KUBUTAMBAHAN
      //****UNIT SAMBIRENTENG CABANG KUBUTAMBAHAN */
      const dataUnitSambirenteng = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.cabang_id",
        6,
        2
      );
      bagianTitle = this.prepare_data_seksi(dataUnitSambirenteng, 6, 2);
      bagianPemimpin = this.prepare_data_pemimpin(dataUnitSambirenteng); //cari id kacab
      bagianStaf = this.prepare_data_staf(dataUnitSambirenteng);

      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN",
        "CABANG KUBUTAMBAHAN UNIT SAMBIRENTENG",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.seksi_id"
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataUnitSambirenteng
      );
      row = row + 15;
      //END OF SAMBIRENTENG
      //****CABANG LOVINA  */
      const dataCabangLovina = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.cabang_id",
        5
      );
      bagianTitle = this.prepare_data_seksi(dataCabangLovina, 5);
      bagianPemimpin = this.prepare_data_pemimpin(dataCabangLovina); //cari id kacab
      bagianStaf = this.prepare_data_staf(dataCabangLovina);

      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN",
        "CABANG LOVINA",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.seksi_id"
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataCabangLovina
      );
      row = row + 15;
      //END CABANG LOVINA

      //****UNIT PANCASARI CABANG LOVINA */
      const dataUnitPancasari = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.cabang_id",
        5,
        1
      );
      bagianTitle = this.prepare_data_seksi(dataUnitPancasari, 5, 1);
      bagianPemimpin = this.prepare_data_pemimpin(dataUnitPancasari); //cari id kacab
      bagianStaf = this.prepare_data_staf(dataUnitPancasari);

      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN",
        "CABANG LOVINA UNIT PANCASARI",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.seksi_id"
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataUnitPancasari
      );
      row = row + 15;
      //END OF PANCASARI

      //***CABANG SERIRIT */
      const dataCabangSeririt = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.cabang_id",
        4
      );
      bagianTitle = this.prepare_data_seksi(dataCabangSeririt, 4); //seksi pada cabang //get unique from dataCabangSeririt and get seksi_nama
      bagianPemimpin = this.prepare_data_pemimpin(dataCabangSeririt); //cari id kacab
      bagianStaf = this.prepare_data_staf(dataCabangSeririt);
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN",
        "CABANG SERIRIT",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.seksi_id"
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataCabangSeririt
      );
      row = row + 15;
      //***END OF CABANG SERIRIT */

      //***CABANG GEROKGAK */
      const dataCabangGerokgak = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.cabang_id",
        2
      );
      bagianTitle = this.prepare_data_seksi(dataCabangGerokgak, 2); //seksi pada cabang //get unique from dataCabangSeririt and get seksi_nama
      bagianPemimpin = this.prepare_data_pemimpin(dataCabangGerokgak); //cari id kacab
      bagianStaf = this.prepare_data_staf(dataCabangGerokgak);
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN",
        "CABANG GEROKGAK",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.seksi_id"
      ); //isi data
      row = this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataCabangGerokgak
      );
      row = row + 15;
      //***END OF CABANG GEROKGAK */
      //***CABANG BUSUNGBIU */
      const dataCabangBusungbiu = this.prepare_data_excel(
        dataTetapCapeg,
        "riwayat_pekerjaan.cabang_id",
        3
      );
      bagianTitle = this.prepare_data_seksi(dataCabangBusungbiu, 3); //seksi pada cabang //get unique from dataCabangSeririt and get seksi_nama
      bagianPemimpin = this.prepare_data_pemimpin(dataCabangBusungbiu); //cari id kacab
      bagianStaf = this.prepare_data_staf(dataCabangBusungbiu);
      row = this.wbAddHeaderTetap(
        workbook,
        sheetName,
        row,
        "DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN",
        "CABANG BUSUNGBIU",
        "UNTUK BULAN  : " + this.periodeTitle.toUpperCase()
      );
      row = this.wbAddHeaderKomponen(workbook, sheetName, row); //nama, no, golongan
      row = this.wbAddContentTetapPerBagian(
        workbook,
        sheetName,
        row,
        bagianTitle,
        bagianPemimpin,
        bagianStaf,
        "riwayat_pekerjaan.seksi_id"
      ); //isi data
      this.wbAddContentTetapFooter(
        workbook,
        sheetName,
        row,
        dataCabangBusungbiu
      );

      //END OF BUSUNGBIU

      //HONOR

      XLSX.writeFile(workbook, "Gaji " + this.periodeTitle + ".xlsx");
    },

    wbAddHeaderHonor(workbook, sheetName, row, title1, title2, title3 = null) {
      const ws = workbook.Sheets[sheetName];
      if (title3 !== "pusat") row = row + 10;
      this.wbAoa(ws, title1, "A" + row);
      row += 1;
      this.wbAoa(ws, title2, "A" + row);
      if (title3 !== null) {
        row += 1;
        this.wbAoa(ws, title3, "A" + row);
      }

      return row + 2;
    },

    wbAddHeaderTetap(workbook, sheetName, row, title1, title2, title3 = null) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "PERUSAHAAN UMUM DAERAH AIR MINUM", "B" + row);
      row += 1;
      this.wbAoa(ws, "TIRTA HITA BULELENG", "B" + row);
      row += 1;
      this.wbAoa(ws, title1, "A" + row);
      row += 1;
      this.wbAoa(ws, title2, "A" + row);
      if (title3 !== null) {
        row += 1;
        this.wbAoa(ws, title3, "A" + row);
      }

      return row + 2;
    },
    wbAddHeaderKomponen(workbook, sheetName, row) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "NO.", "A" + row);
      this.wbAoa(ws, "NAMA", "B" + row);
      this.wbAoa(ws, "GOL", "C" + row);
      this.wbAoa(ws, "GAJI POKOK", "E" + row);
      this.wbAoa(ws, "TUNJANGAN", "F" + row);
      this.wbAoa(ws, "POT. KETIDAKHADIRAN", "M" + row);
      this.wbAoa(ws, "JML BRUTO", "O" + row);
      this.wbAoa(ws, "TUNJANGAN PPH", "P" + row);
      this.wbAoa(ws, "JUMLAH", "Q" + row);
      this.wbAoa(ws, "POTONGAN", "R" + row);
      this.wbAoa(ws, "JUMLAH YANG DITERIMA", "W" + row);
      this.wbAoa(ws, "TANDA TANGAN", "Y" + row);

      row += 1;
      this.wbAoa(ws, "NIP/NIK", "B" + row);
      this.wbAoa(ws, "PERUSAHAAN", "F" + row);
      this.wbAoa(ws, "PERUSAHAAN", "F" + row);
      this.wbAoa(ws, "JABATAN", "G" + row);
      this.wbAoa(ws, "KEMAHALAN", "H" + row);
      this.wbAoa(ws, "AIR", "I" + row);
      this.wbAoa(ws, "TRANSPORT", "J" + row);
      this.wbAoa(ws, "PANGAN", "K" + row);
      this.wbAoa(ws, "KESEHATAN", "L" + row);
      this.wbAoa(ws, "HARI", "M" + row);
      this.wbAoa(ws, "JUMLAH", "N" + row);
      this.wbAoa(ws, "KESEHATAN", "R" + row);
      this.wbAoa(ws, "BPJS TK 3 PROGRAM", "S" + row);
      this.wbAoa(ws, "BPJS TK 4 PROGRAM", "T" + row);
      this.wbAoa(ws, "PENSIUN JIWASRAYA", "U" + row);
      this.wbAoa(ws, "PPH", "V" + row);

      row += 1;
      this.wbAoa(ws, "JABATAN", "B" + row);
      this.wbAoa(ws, "(5) X 25%", "F" + row);
      this.wbAoa(ws, "(5) X 5%", "H" + row);
      this.wbAoa(ws, "13X5%(6+10)", "N" + row);
      this.wbAoa(ws, "(14+15)", "Q" + row);
      this.wbAoa(ws, "(15)X2%)", "S" + row);
      this.wbAoa(ws, "(Bts maxX1% JP)", "T" + row);

      row += 1;
      this.wbAoa(ws, "+ 2% JHT", "T" + row);
      row += 1;
      this.wbAoa(ws, "(Rp.)", "F" + row);
      this.wbAoa(ws, "(Rp.)", "G" + row);
      this.wbAoa(ws, "(Rp.)", "H" + row);
      this.wbAoa(ws, "(Rp.)", "I" + row);
      this.wbAoa(ws, "(Rp.)", "J" + row);
      this.wbAoa(ws, "(Rp.)", "K" + row);
      this.wbAoa(ws, "(Rp.)", "L" + row);
      this.wbAoa(ws, "(Rp.)", "N" + row);
      this.wbAoa(ws, "(Rp.)", "O" + row);
      this.wbAoa(ws, "(Rp.)", "P" + row);
      this.wbAoa(ws, "(Rp.)", "Q" + row);
      this.wbAoa(ws, "(Rp.)", "R" + row);
      this.wbAoa(ws, "(Rp.)", "S" + row);
      this.wbAoa(ws, "(Rp.)", "T" + row);
      this.wbAoa(ws, "(Rp.)", "U" + row);
      this.wbAoa(ws, "(Rp.)", "V" + row);
      this.wbAoa(ws, "(Rp.)", "W" + row);
      row += 1;

      this.wbAoa(ws, "1", "A" + row);
      this.wbAoa(ws, "2", "B" + row);
      this.wbAoa(ws, "3", "C" + row);
      this.wbAoa(ws, "4", "D" + row);
      this.wbAoa(ws, "5", "E" + row);
      this.wbAoa(ws, "6", "F" + row);
      this.wbAoa(ws, "7", "G" + row);
      this.wbAoa(ws, "8", "H" + row);
      this.wbAoa(ws, "9", "I" + row);
      this.wbAoa(ws, "10", "J" + row);
      this.wbAoa(ws, "11", "K" + row);
      this.wbAoa(ws, "12", "L" + row);
      this.wbAoa(ws, "13", "M" + row);
      this.wbAoa(ws, "14", "N" + row);
      this.wbAoa(ws, "15", "O" + row);
      this.wbAoa(ws, "16", "P" + row);
      this.wbAoa(ws, "17", "Q" + row);
      this.wbAoa(ws, "18", "R" + row);
      this.wbAoa(ws, "19", "S" + row);
      this.wbAoa(ws, "20", "T" + row);
      this.wbAoa(ws, "21", "U" + row);
      this.wbAoa(ws, "22", "V" + row);
      this.wbAoa(ws, "23", "W" + row);
      this.wbAoa(ws, "24", "Y" + row);

      return row + 2;
    },
    wbAddHeaderKomponenHonor(workbook, sheetName, row) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "MASA", "E" + row);
      this.wbAoa(ws, "TMT", "F" + row);
      this.wbAoa(ws, "HONOR", "G" + row);
      this.wbAoa(ws, "KENAIKAN MASA", "H" + row);
      this.wbAoa(ws, "TUNJ.", "I" + row);
      this.wbAoa(ws, "JML", "J" + row);
      this.wbAoa(ws, "POT.", "K" + row);
      this.wbAoa(ws, "JUMLAH", "L" + row);
      this.wbAoa(ws, "POTONGAN", "M" + row);
      this.wbAoa(ws, "HONOR", "O" + row);
      this.wbAoa(ws, "TANDA", "Q" + row);

      row += 1;
      this.wbAoa(ws, "NO", "A" + row);
      this.wbAoa(ws, "NAMA", "B" + row);
      this.wbAoa(ws, "GOLONGAN", "C" + row);
      this.wbAoa(ws, "JABATAN", "D" + row);
      this.wbAoa(ws, "KERJA", "E" + row);
      this.wbAoa(ws, "KONTRAK", "F" + row);
      this.wbAoa(ws, "(UMK)", "G" + row);
      this.wbAoa(ws, "KERJA", "H" + row);
      this.wbAoa(ws, "KESEHATAN", "I" + row);
      this.wbAoa(ws, "TIDAK", "J" + row);
      this.wbAoa(ws, "(5%x6)9", "K" + row);
      this.wbAoa(ws, "BRUTO", "L" + row);
      this.wbAoa(ws, "KESEHATAN", "M" + row);
      this.wbAoa(ws, "BPJS TK", "N" + row);
      this.wbAoa(ws, "DITERIMA", "O" + row);
      this.wbAoa(ws, "TANGAN", "Q" + row);

      row += 1;
      this.wbAoa(ws, "(MK x 3% x UMK)", "H" + row);
      this.wbAoa(ws, "MASUK", "J" + row);
      this.wbAoa(ws, "(9)x2%", "N" + row);

      row += 1;
      this.wbAoa(ws, "(Rp.)", "G" + row);
      this.wbAoa(ws, "(Rp.)", "H" + row);
      this.wbAoa(ws, "(Rp.)", "I" + row);
      this.wbAoa(ws, "(Rp.)", "K" + row);
      this.wbAoa(ws, "(Rp.)", "L" + row);
      this.wbAoa(ws, "(Rp.)", "M" + row);
      this.wbAoa(ws, "(Rp.)", "N" + row);
      this.wbAoa(ws, "(Rp.)", "O" + row);
      row += 1;

      this.wbAoa(ws, "1", "A" + row);
      this.wbAoa(ws, "2", "B" + row);
      this.wbAoa(ws, "3", "C" + row);
      this.wbAoa(ws, "4", "D" + row);
      this.wbAoa(ws, "5", "E" + row);
      this.wbAoa(ws, "6", "F" + row);
      this.wbAoa(ws, "7", "G" + row);
      this.wbAoa(ws, "8", "H" + row);
      this.wbAoa(ws, "9", "I" + row);
      this.wbAoa(ws, "10", "J" + row);
      this.wbAoa(ws, "11", "K" + row);
      this.wbAoa(ws, "12", "L" + row);
      this.wbAoa(ws, "13", "M" + row);
      this.wbAoa(ws, "14", "N" + row);
      this.wbAoa(ws, "15", "O" + row);
      this.wbAoa(ws, "16", "Q" + row);

      return row + 2;
    },

    wbAddHeaderKomponenKontrak(workbook, sheetName, row) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "MASA", "E" + row);
      this.wbAoa(ws, "TMT", "F" + row);
      this.wbAoa(ws, "HONOR", "G" + row);
      this.wbAoa(ws, "KENAIKAN MASA", "H" + row);
      this.wbAoa(ws, "TUNJ.", "I" + row);
      this.wbAoa(ws, "JML", "J" + row);
      this.wbAoa(ws, "POT.", "K" + row);
      this.wbAoa(ws, "JUMLAH", "L" + row);
      this.wbAoa(ws, "TUNJ.", "M" + row);
      this.wbAoa(ws, "JUMLAH", "N" + row);
      this.wbAoa(ws, "POTONGAN", "O" + row);
      this.wbAoa(ws, "HONOR", "Q" + row);
      this.wbAoa(ws, "TANDA", "S" + row);

      row += 1;
      this.wbAoa(ws, "NO", "A" + row);
      this.wbAoa(ws, "NAMA", "B" + row);
      this.wbAoa(ws, "GOLONGAN", "C" + row);
      this.wbAoa(ws, "JABATAN", "D" + row);
      this.wbAoa(ws, "KERJA", "E" + row);
      this.wbAoa(ws, "KONTRAK", "F" + row);
      this.wbAoa(ws, "(UMK)", "G" + row);
      this.wbAoa(ws, "KERJA", "H" + row);
      this.wbAoa(ws, "KESEHATAN", "I" + row);
      this.wbAoa(ws, "TIDAK", "J" + row);
      this.wbAoa(ws, "(2%x7)10", "K" + row);
      this.wbAoa(ws, "BPJS", "M" + row);
      this.wbAoa(ws, "BRUTO", "N" + row);
      this.wbAoa(ws, "KESEHATAN", "O" + row);
      this.wbAoa(ws, "BPJS TK", "P" + row);
      this.wbAoa(ws, "DITERIMA", "Q" + row);
      this.wbAoa(ws, "TANGAN", "S" + row);

      row += 1;
      this.wbAoa(ws, "MASUK", "J" + row);
      this.wbAoa(ws, "T. KERJA", "M" + row);
      this.wbAoa(ws, "(11)x1.19%", "P" + row);

      row += 1;
      this.wbAoa(ws, "(Rp.)", "G" + row);
      this.wbAoa(ws, "(Rp.)", "H" + row);
      this.wbAoa(ws, "(Rp.)", "I" + row);
      this.wbAoa(ws, "(Rp.)", "K" + row);
      this.wbAoa(ws, "(Rp.)", "L" + row);
      this.wbAoa(ws, "(Rp.)", "M" + row);
      this.wbAoa(ws, "(Rp.)", "N" + row);
      this.wbAoa(ws, "(Rp.)", "O" + row);
      this.wbAoa(ws, "(Rp.)", "P" + row);
      this.wbAoa(ws, "(Rp.)", "Q" + row);
      row += 1;

      this.wbAoa(ws, "1", "A" + row);
      this.wbAoa(ws, "2", "B" + row);
      this.wbAoa(ws, "3", "C" + row);
      this.wbAoa(ws, "4", "D" + row);
      this.wbAoa(ws, "5", "E" + row);
      this.wbAoa(ws, "6", "F" + row);
      this.wbAoa(ws, "7", "G" + row);
      this.wbAoa(ws, "8", "H" + row);
      this.wbAoa(ws, "9", "I" + row);
      this.wbAoa(ws, "10", "J" + row);
      this.wbAoa(ws, "11", "K" + row);
      this.wbAoa(ws, "12", "L" + row);
      this.wbAoa(ws, "13", "M" + row);
      this.wbAoa(ws, "14", "N" + row);
      this.wbAoa(ws, "15", "O" + row);
      this.wbAoa(ws, "16", "P" + row);
      this.wbAoa(ws, "17", "Q" + row);
      this.wbAoa(ws, "18", "S" + row);

      return row + 2;
    },

    prepare_excel_golongan(golonganId) {
      if (golonganId > 4) return "B";
      if (golonganId < 5) return "A";
    },
    prepare_excel_jabatan(riwayatPekerjaan) {
      if (riwayatPekerjaan.sub_bagian_id !== null)
        return (
          "Staf Sub Bag. " +
          _.find(this.commonStore.subBagianStore, {
            id: riwayatPekerjaan.sub_bagian_id,
          }).nama
        );
      if (riwayatPekerjaan.sub_bidang_id !== null)
        return (
          "Staf Sub Bid. " +
          _.find(this.commonStore.subBidangStore, {
            id: riwayatPekerjaan.sub_bidang_id,
          }).nama
        );
      if (riwayatPekerjaan.unit_id != null) {
        return (
          "Staf Unit. " +
          _.find(this.commonStore.unitStore, { id: riwayatPekerjaan.unit_id })
            .nama
        );
      }
      if (riwayatPekerjaan.seksi_id != null) {
        if (riwayatPekerjaan.seksi_id > 2) return "Staf Seksi Teknik";
        return (
          "Staf Seksi " +
          _.find(this.commonStore.seksiStore, { id: riwayatPekerjaan.seksi_id })
            .nama
        );
      }
      return (
        "Staf Cabang " +
        _.find(this.commonStore.cabangStore, { id: riwayatPekerjaan.cabang_id })
          .nama
      );
    },

    prepare_excel_tgl(tgl) {
      const dateObj = DateTime.fromISO(tgl);

      return dateObj.toFormat("dd LLL yyyy");
    },

    wbAddContentKontrak(workbook, sheetName, row, numbering, data) {
      const ws = workbook.Sheets[sheetName];
      numbering += 1;

      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, e.pegawai.nama, "B" + row);
        this.wbAoa(ws, this.prepare_excel_golongan(e.golongan_id), "C" + row); //if b1 = B, a1,2, = A
        this.wbAoa(
          ws,
          this.prepare_excel_jabatan(e.riwayat_pekerjaan),
          "D" + row
        );
        this.wbAoa(ws, e.masa_kerja + " tahun", "E" + row);
        this.wbAoa(
          ws,
          this.prepare_excel_tgl(e.riwayat_pekerjaan.tgl_mulai_bekerja),
          "F" + row
        );
        this.wbAoa(ws, e.honor_umk_jml, "G" + row);
        this.wbAoa(ws, e.kenaikan_masa_kerja, "H" + row);
        this.wbAoa(ws, e.tun_kesehatan, "I" + row);
        this.wbAoa(ws, e.absen_bulan.tidak_hadir, "J" + row);
        this.wbAoa(ws, e.pot_5_persen, "K" + row);
        this.wbAoa(
          ws,
          e.honor_umk_jml +
            e.kenaikan_masa_kerja +
            e.tun_kesehatan -
            e.pot_5_persen,
          "L" + row
        );
        this.wbAoa(ws, e.tun_bpjs_tk_satu_sembilanbelas_persen, "M" + row);

        this.wbAoa(ws, e.jml_bruto, "N" + row);
        this.wbAoa(ws, e.pot_kesehatan, "O" + row);
        this.wbAoa(ws, e.pot_bpjs_tk_satu_sembilanbelas_persen, "P" + row);
        this.wbAoa(ws, e.total_diterima, "Q" + row);
        this.wbAoa(ws, numbering, "R" + row);
        this.wbAoa(ws, "........................", "S" + row);
        row += 1;
        numbering++;
      });
      return row;
    },

    wbAddContentHonor(workbook, sheetName, row, numbering, data) {
      const ws = workbook.Sheets[sheetName];
      numbering += 1;

      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, e.pegawai.nama, "B" + row);
        this.wbAoa(ws, this.prepare_excel_golongan(e.golongan_id), "C" + row); //if b1 = B, a1,2, = A
        this.wbAoa(
          ws,
          this.prepare_excel_jabatan(e.riwayat_pekerjaan),
          "D" + row
        );
        this.wbAoa(ws, e.masa_kerja + " tahun", "E" + row);
        this.wbAoa(
          ws,
          this.prepare_excel_tgl(e.riwayat_pekerjaan.tgl_mulai_bekerja),
          "F" + row
        );
        this.wbAoa(ws, e.honor_umk_jml, "G" + row);
        this.wbAoa(ws, e.kenaikan_masa_kerja, "H" + row);
        this.wbAoa(ws, e.tun_kesehatan, "I" + row);
        this.wbAoa(ws, e.absen_bulan.tidak_hadir, "J" + row);
        this.wbAoa(ws, e.pot_5_persen, "K" + row);
        this.wbAoa(ws, e.jml_bruto, "L" + row);
        this.wbAoa(ws, e.pot_kesehatan, "M" + row);
        this.wbAoa(ws, e.pot_bpjs_tk_dua_persen, "N" + row);
        this.wbAoa(ws, e.total_diterima, "O" + row);
        this.wbAoa(ws, numbering, "P" + row);
        this.wbAoa(ws, "........................", "Q" + row);
        row += 1;
        numbering++;
      });
      return row;
    },

    // workbook,
    //     sheetName,
    //     row,
    //     bagianTitle,
    //     bagianPemimpin,
    //     bagianStaf,
    //     "riwayat_pekerjaan.sub_bidang_id"
    // wbAddContentTetapPerBagian(workbook, sheetName, row, numbering, staf) {
    wbAddContentTetapPerBagian(
      workbook,
      sheetName,
      row,
      bagianTitle,
      bagianPemimpin,
      bagianStaf,
      filterStaf
    ) {
      const ws = workbook.Sheets[sheetName];
      var numbering = 0;
      bagianTitle.forEach((b, bIndex) => {
        this.wbAoa(ws, b.nama, "B" + row);
        row += 1;
        if (bIndex === 0 && bagianPemimpin.length > 0) {
          //pemimpin kabag/kacab/kabid
          row = this.wbAddContentTetapStaf(
            numbering,
            workbook,
            sheetName,
            row,
            bagianPemimpin
          );
          numbering += 1;
        } else {
          var staf = _.filter(bagianStaf, (item) => {
            return _.get(item, filterStaf) === b.id;
          });
          row = this.wbAddContentTetapStaf(
            numbering,
            workbook,
            sheetName,
            row,
            staf
          );
          numbering = numbering + staf.length;
        }
      });
      return row;
    },

    wbAddContentTetapStaf(numbering, workbook, sheetName, row, data) {
      const ws = workbook.Sheets[sheetName];
      numbering += 1;

      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, e.pegawai.nama, "B" + row);
        this.wbAoa(ws, e.golongan.nama, "C" + row);
        this.wbAoa(ws, e.status_ptkp, "D" + row);
        this.wbAoa(ws, e.gaji_pokok, "E" + row);
        this.wbAoa(ws, e.tun_perusahaan, "F" + row);
        this.wbAoa(ws, e.tun_jabatan, "G" + row);
        this.wbAoa(ws, e.tun_kemahalan, "H" + row);
        this.wbAoa(ws, e.tun_air, "I" + row);
        this.wbAoa(ws, e.tun_transport, "J" + row);
        this.wbAoa(ws, e.tun_pangan, "K" + row);
        this.wbAoa(ws, e.tun_kesehatan, "L" + row);
        this.wbAoa(ws, e.absen_bulan.tidak_hadir, "M" + row);
        this.wbAoa(ws, e.pot_5_persen, "N" + row);
        this.wbAoa(ws, e.jml_bruto, "O" + row);
        this.wbAoa(ws, e.tun_pph, "P" + row);
        this.wbAoa(ws, e.jml_bruto + e.tun_pph, "Q" + row);
        this.wbAoa(ws, e.pot_kesehatan, "R" + row);
        this.wbAoa(ws, e.pot_bpjs_tk_tiga_program, "S" + row);
        this.wbAoa(ws, e.pot_bpjs_tk_empat_program, "T" + row);
        this.wbAoa(ws, e.pot_pensiun, "U" + row);
        this.wbAoa(ws, e.pot_pph, "V" + row);
        this.wbAoa(ws, e.total_diterima, "W" + row);
        // this.wbAoa(ws, index + 1, "X" + row);
        this.wbAoa(ws, numbering, "X" + row);
        this.wbAoa(ws, "........................", "Y" + row);
        row += 1;
        this.wbAoa(ws, "NIK. " + e.pegawai.nik, "B" + row);
        row += 1;
        numbering++;
      });
      return row;
    },

    wbAddContentTetapFooter(workbook, sheetName, row, data) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "JUMLAH", "B" + row);
      const totalJml1415 =
        this.prepare_data_hitung_total(data, "jml_bruto") +
        this.prepare_data_hitung_total(data, "tun_pph");
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "gaji_pokok"),
        "E" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_perusahaan"),
        "F" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_jabatan"),
        "G" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_kemahalan"),
        "H" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_air"),
        "I" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_transport"),
        "J" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_pangan"),
        "K" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_kesehatan"),
        "L" + row
      );
      const totalTidakHadir = data.reduce(
        (total, item) => total + item.absen_bulan.tidak_hadir,
        0
      );

      this.wbAoa(ws, totalTidakHadir, "M" + row);
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_5_persen"),
        "N" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "jml_bruto"),
        "O" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_pph"),
        "P" + row
      );
      this.wbAoa(ws, totalJml1415, "Q" + row);
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_kesehatan"),
        "R" + row
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_bpjs_tk_tiga_program"),
        "S" + row
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_bpjs_tk_empat_program"),
        "T" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_pensiun"),
        "U" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_pph"),
        "V" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "total_diterima"),
        "W" + row
      );

      row += 1;
      this.wbAoa(
        ws,
        "Terbilang: ==== " + this.formatNumberTerbilang(totalJml1415) + " ====",
        "A" + row
      );
      row += 2;
      this.wbAoa(ws, "Perumda Air Minum", "B" + row);
      row += 1;
      this.wbAoa(ws, "Tirta Hita Buleleng", "B" + row);
      this.wbAoa(ws, "Singaraja, ", "U" + row);
      row += 1;
      this.wbAoa(ws, "Mengetahui:", "B" + row);
      this.wbAoa(ws, "Diperiksa", "J" + row);
      this.wbAoa(ws, "Dibuat Oleh:", "U" + row);
      row += 4;
      this.wbAoa(ws, this.pejabatDirum, "B" + row);
      this.wbAoa(ws, this.pejabatKabagUmum, "J" + row);
      this.wbAoa(ws, this.pejabatKasubagPersonalia, "U" + row);
      row += 4;
      this.wbAoa(ws, "Direktur Umum", "B" + row);
      this.wbAoa(ws, "Kepala Bagian Umum", "J" + row);
      this.wbAoa(ws, "Ka. Sub Bag. Personalia", "U" + row);

      return row;
    },

    wbAddContentHonorFooterTerbilang(workbook, sheetName, row, data) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "TOTAL", "B" + row);

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "honor_umk_jml"),
        "G" + row
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "kenaikan_masa_kerja"),
        "H" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_kesehatan"),
        "I" + row
      );

      const totalTidakHadir = data.reduce(
        (total, item) => total + item.absen_bulan.tidak_hadir,
        0
      );
      this.wbAoa(ws, totalTidakHadir, "J" + row);

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_5_persen"),
        "K" + row
      );
      var totalBruto = this.prepare_data_hitung_total(data, "jml_bruto");
      this.wbAoa(ws, totalBruto, "L" + row);
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_kesehatan"),
        "M" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_bpjs_tk_dua_persen"),
        "N" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "total_diterima"),
        "O" + row
      );

      row += 1;
      this.wbAoa(
        ws,
        "Terbilang: ==== " + this.formatNumberTerbilang(totalBruto) + " ====",
        "A" + row
      );
      row += 2;
      this.wbAoa(ws, "Perumda Air Minum", "B" + row);
      row += 1;
      this.wbAoa(ws, "Tirta Hita Buleleng", "B" + row);
      this.wbAoa(ws, "Singaraja, ", "U" + row);
      row += 1;
      this.wbAoa(ws, "Mengetahui:", "B" + row);
      this.wbAoa(ws, "Diperiksa", "J" + row);
      this.wbAoa(ws, "Dibuat Oleh:", "U" + row);
      row += 4;
      this.wbAoa(ws, this.pejabatDirum, "B" + row);
      this.wbAoa(ws, this.pejabatKabagUmum, "J" + row);
      this.wbAoa(ws, this.pejabatKasubagPersonalia, "U" + row);
      row += 4;
      this.wbAoa(ws, "Direktur Umum", "B" + row);
      this.wbAoa(ws, "Kepala Bagian Umum", "J" + row);
      this.wbAoa(ws, "Ka. Sub Bag. Personalia", "U" + row);

      return row;
    },

    wbAddContentKontrakFooterTerbilang(workbook, sheetName, row, data) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "TOTAL", "B" + row);

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "honor_umk_jml"),
        "G" + row
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "kenaikan_masa_kerja"),
        "H" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_kesehatan"),
        "I" + row
      );

      const totalTidakHadir = data.reduce(
        (total, item) => total + item.absen_bulan.tidak_hadir,
        0
      );
      this.wbAoa(ws, totalTidakHadir, "J" + row);

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_5_persen"),
        "K" + row
      );
      const jmlUmkMkTunKesehatanTidakhadir =
        this.prepare_data_hitung_total(data, "honor_umk_jml") +
        this.prepare_data_hitung_total(data, "kenaikan_masa_kerja") +
        this.prepare_data_hitung_total(data, "tun_kesehatan") -
        this.prepare_data_hitung_total(data, "pot_5_persen");

      this.wbAoa(ws, jmlUmkMkTunKesehatanTidakhadir, "L" + row);
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(
          data,
          "tun_bpjs_tk_satu_sembilanbelas_persen"
        ),
        "M" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "jml_bruto"),
        "N" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_kesehatan"),
        "O" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(
          data,
          "pot_bpjs_tk_satu_sembilanbelas_persen"
        ),
        "P" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "total_diterima"),
        "Q" + row
      );
      row += 1;
      this.wbAoa(
        ws,
        "Terbilang: ==== " +
          this.formatNumberTerbilang(jmlUmkMkTunKesehatanTidakhadir) +
          " ====",
        "A" + row
      );
      row += 2;
      this.wbAoa(ws, "Perumda Air Minum", "B" + row);
      row += 1;
      this.wbAoa(ws, "Tirta Hita Buleleng", "B" + row);
      this.wbAoa(ws, "Singaraja, ", "U" + row);
      row += 1;
      this.wbAoa(ws, "Mengetahui:", "B" + row);
      this.wbAoa(ws, "Diperiksa", "J" + row);
      this.wbAoa(ws, "Dibuat Oleh:", "U" + row);
      row += 4;
      this.wbAoa(ws, this.pejabatDirum, "B" + row);
      this.wbAoa(ws, this.pejabatKabagUmum, "J" + row);
      this.wbAoa(ws, this.pejabatKasubagPersonalia, "U" + row);
      row += 4;
      this.wbAoa(ws, "Direktur Umum", "B" + row);
      this.wbAoa(ws, "Kepala Bagian Umum", "J" + row);
      this.wbAoa(ws, "Ka. Sub Bag. Personalia", "U" + row);

      return row;
    },

    wbAddContentHonorFooter(workbook, sheetName, row, data) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "JUMLAH", "B" + row);

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "honor_umk_jml"),
        "G" + row
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "kenaikan_masa_kerja"),
        "H" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_kesehatan"),
        "I" + row
      );

      const totalTidakHadir = data.reduce(
        (total, item) => total + item.absen_bulan.tidak_hadir,
        0
      );
      this.wbAoa(ws, totalTidakHadir, "J" + row);

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_5_persen"),
        "K" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "jml_bruto"),
        "L" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_kesehatan"),
        "M" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_bpjs_tk_dua_persen"),
        "N" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "total_diterima"),
        "O" + row
      );

      row += 1;

      return row;
    },

    wbAddContentKontrakFooter(workbook, sheetName, row, data) {
      const ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "JUMLAH", "B" + row);

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "honor_umk_jml"),
        "G" + row
      );

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "kenaikan_masa_kerja"),
        "H" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "tun_kesehatan"),
        "I" + row
      );

      const totalTidakHadir = data.reduce(
        (total, item) => total + item.absen_bulan.tidak_hadir,
        0
      );
      this.wbAoa(ws, totalTidakHadir, "J" + row);

      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_5_persen"),
        "K" + row
      );
      const jmlUmkMkTunKesehatanTidakhadir =
        this.prepare_data_hitung_total(data, "honor_umk_jml") +
        this.prepare_data_hitung_total(data, "kenaikan_masa_kerja") +
        this.prepare_data_hitung_total(data, "tun_kesehatan") -
        this.prepare_data_hitung_total(data, "pot_5_persen");

      this.wbAoa(ws, jmlUmkMkTunKesehatanTidakhadir, "L" + row);
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(
          data,
          "tun_bpjs_tk_satu_sembilanbelas_persen"
        ),
        "M" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "jml_bruto"),
        "N" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "pot_kesehatan"),
        "O" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(
          data,
          "pot_bpjs_tk_satu_sembilanbelas_persen"
        ),
        "P" + row
      );
      this.wbAoa(
        ws,
        this.prepare_data_hitung_total(data, "total_diterima"),
        "Q" + row
      );

      row += 1;

      return row;
    },

    prepare_data_hitung_total(data, field) {
      return data.reduce((total, item) => total + item[field], 0);
    },

    wbAddContentTetap(workbook, sheetName, row, data) {
      const ws = workbook.Sheets[sheetName];
      const totalGajiPokok = data.reduce(
        (total, item) => total + item.gaji_pokok,
        0
      );
      const totalTunPerusahaan = data.reduce(
        (total, item) => total + item.tun_perusahaan,
        0
      );
      const totalTunJabatan = data.reduce(
        (total, item) => total + item.tun_jabatan,
        0
      );
      const totalTunKemahalan = data.reduce(
        (total, item) => total + item.tun_kemahalan,
        0
      );
      const totalTunAir = data.reduce((total, item) => total + item.tun_air, 0);
      const totalTunTransport = data.reduce(
        (total, item) => total + item.tun_transport,
        0
      );
      const totalTunPangan = data.reduce(
        (total, item) => total + item.tun_pangan,
        0
      );
      const totalTunKesehatan = data.reduce(
        (total, item) => total + item.tun_kesehatan,
        0
      );
      const totalTidakHadir = data.reduce(
        (total, item) => total + item.absen_bulan.tidak_hadir,
        0
      );
      const totalPotTidakHadir = data.reduce(
        (total, item) => total + item.pot_5_persen,
        0
      );

      const totalJmlBruto = data.reduce(
        (total, item) => total + item.jml_bruto,
        0
      );
      const totalTunPph = data.reduce((total, item) => total + item.tun_pph, 0);

      const totalPotKesehatan = data.reduce(
        (total, item) => total + item.pot_kesehatan,
        0
      );
      const totalPotBpjsTk3 = data.reduce(
        (total, item) => total + item.pot_bpjs_tk_tiga_program,
        0
      );
      const totalPotBpjsTk4 = data.reduce(
        (total, item) => total + item.pot_bpjs_tk_empat_program,
        0
      );
      const totalPotPensiun = data.reduce(
        (total, item) => total + item.pot_pensiun,
        0
      );
      const totalPotPph = data.reduce((total, item) => total + item.pot_pph, 0);
      const totalTotalDiterima = data.reduce(
        (total, item) => total + item.total_diterima,
        0
      );
      const totalJml1415 = totalJmlBruto + totalTunPph;

      data.forEach((e, index) => {
        this.wbAoa(ws, index + 1, "A" + row);
        this.wbAoa(ws, e.pegawai.nama, "B" + row);
        this.wbAoa(ws, e.golongan.nama, "C" + row);
        this.wbAoa(ws, e.status_ptkp, "D" + row);
        this.wbAoa(ws, e.gaji_pokok, "E" + row);
        this.wbAoa(ws, e.tun_perusahaan, "F" + row);
        this.wbAoa(ws, e.tun_jabatan, "G" + row);
        this.wbAoa(ws, e.tun_kemahalan, "H" + row);
        this.wbAoa(ws, e.tun_air, "I" + row);
        this.wbAoa(ws, e.tun_transport, "J" + row);
        this.wbAoa(ws, e.tun_pangan, "K" + row);
        this.wbAoa(ws, e.tun_kesehatan, "L" + row);
        this.wbAoa(ws, e.absen_bulan.tidak_hadir, "M" + row);
        this.wbAoa(ws, e.pot_5_persen, "N" + row);
        this.wbAoa(ws, e.jml_bruto, "O" + row);
        this.wbAoa(ws, e.tun_pph, "P" + row);
        this.wbAoa(ws, e.jml_bruto + e.tun_pph, "Q" + row);
        this.wbAoa(ws, e.pot_kesehatan, "R" + row);
        this.wbAoa(ws, e.pot_bpjs_tk_tiga_program, "S" + row);
        this.wbAoa(ws, e.pot_bpjs_tk_empat_program, "T" + row);
        this.wbAoa(ws, e.pot_pensiun, "U" + row);
        this.wbAoa(ws, e.pot_pph, "V" + row);
        this.wbAoa(ws, e.total_diterima, "W" + row);
        this.wbAoa(ws, index + 1, "X" + row);
        this.wbAoa(ws, "........................", "Y" + row);
        row += 1;
        this.wbAoa(ws, "NIK. " + e.pegawai.nik, "B" + row);
        row += 1;
      });
      row += 1;
      this.wbAoa(ws, "JUMLAH", "B" + row);
      this.wbAoa(ws, totalGajiPokok, "E" + row);
      this.wbAoa(ws, totalTunPerusahaan, "F" + row);
      this.wbAoa(ws, totalTunJabatan, "G" + row);
      this.wbAoa(ws, totalTunKemahalan, "H" + row);
      this.wbAoa(ws, totalTunAir, "I" + row);
      this.wbAoa(ws, totalTunTransport, "J" + row);
      this.wbAoa(ws, totalTunPangan, "K" + row);
      this.wbAoa(ws, totalTunKesehatan, "L" + row);
      this.wbAoa(ws, totalTidakHadir, "M" + row);
      this.wbAoa(ws, totalPotTidakHadir, "N" + row);
      this.wbAoa(ws, totalJmlBruto, "O" + row);
      this.wbAoa(ws, totalTunPph, "P" + row);
      this.wbAoa(ws, totalJml1415, "Q" + row);
      this.wbAoa(ws, totalPotKesehatan, "R" + row);
      this.wbAoa(ws, totalPotBpjsTk3, "S" + row);
      this.wbAoa(ws, totalPotBpjsTk4, "T" + row);
      this.wbAoa(ws, totalPotPensiun, "U" + row);
      this.wbAoa(ws, totalPotPph, "V" + row);
      this.wbAoa(ws, totalTotalDiterima, "W" + row);

      row += 1;
      this.wbAoa(
        ws,
        "Terbilang: ==== " + this.formatNumberTerbilang(totalJml1415) + " ====",
        "A" + row
      );
      row += 2;
      this.wbAoa(ws, "Perumda Air Minum", "B" + row);
      row += 1;
      this.wbAoa(ws, "Tirta Hita Buleleng", "B" + row);
      this.wbAoa(ws, "Singaraja, ", "U" + row);
      row += 1;
      this.wbAoa(ws, "Mengetahui:", "B" + row);
      this.wbAoa(ws, "Diperiksa", "J" + row);
      this.wbAoa(ws, "Dibuat Oleh:", "U" + row);
      row += 4;
      this.wbAoa(ws, this.pejabatDirum, "B" + row);
      this.wbAoa(ws, this.pejabatKabagUmum, "J" + row);
      this.wbAoa(ws, this.pejabatKasubagPersonalia, "U" + row);
      row += 4;
      this.wbAoa(ws, "Direktur Umum", "B" + row);
      this.wbAoa(ws, "Kepala Bagian Umum", "J" + row);
      this.wbAoa(ws, "Ka. Sub Bag. Personalia", "U" + row);

      return row;
    },
    formatNumberTerbilang(value) {
      if (typeof value === "string") {
        value = value.replace(/\./g, "");
      }

      if (value !== null && value !== undefined) {
        // Convert the value to a string and remove the decimal part (".00")
        const stringValue = value.toString().split(".")[0];
        return _.startCase(angkaTerbilang(stringValue));
        // Add thousands separator
        // return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },

    wbAoa(worksheet, text, cell) {
      XLSX.utils.sheet_add_aoa(worksheet, [[text]], {
        origin: cell,
      });
    },
    addSpecificValues(workbook, sheetName) {
      // Get the specific worksheet
      const worksheet = workbook.Sheets[sheetName];

      // Add specific values to specific cells
      XLSX.utils.sheet_add_aoa(worksheet, [["Specific Value1"]], {
        origin: "A1",
      }); // A1 cell
      XLSX.utils.sheet_add_aoa(worksheet, [["Specific Value2"]], {
        origin: "B2",
      }); // B2 cell
      // Add more specific values as needed
    },
    formattedDate(tgl) {
      const jsDate = new Date(tgl);
      const dt = DateTime.fromJSDate(jsDate).setZone("Asia/Makassar");
      const convert = dt
        .setLocale("id")
        .toFormat("cccc dd MMMM yyyy HH:mm:ss 'WITA'");
      const originalDate = DateTime.fromFormat(
        convert,
        "cccc dd MMMM yyyy HH:mm:ss 'WITA'",
        { locale: "id" }
      );

      const newDate = originalDate.plus({ hours: 8 });
      const formattedNewDate = newDate.toFormat(
        "cccc dd MMMM yyyy HH:mm:ss 'WITA'"
      );
      return formattedNewDate;
    },
    templateUpdateByUser(data) {
      if (data.data.editedByUser) {
        return (
          data.data.editedByUser.name +
          ", " +
          this.formattedDate(data.data.updated_at)
        );
      }
      return;
    },
    allowReloadGajiGrid(e) {
      if (e.row.data.status_gaji) return false; //jik status gaji approved, tidak bisa diedit dan direload
      return this.buttonCan("gaji-update");
    },
    allowUpdating() {
      if (this.gajiPeriodeData.gaji_status_id == 3) {
        //approved
        return false;
      }
      if (this.can("gaji-approve") && this.gajiPeriodeData.gaji_status_id == 2)
        return true; //adalah admin dan masuk status request payroll
      if (
        this.can("gaji-update") &&
        (this.gajiPeriodeData.gaji_status_id == 1 ||
          this.gajiPeriodeData.gaji_status_id == 4)
      )
        return true; //adalah admin dan periode status is open/request revision
      return false;
    },
    async rowDblClick(e) {
      if (
        e.rowType === "data" &&
        e.data &&
        this.can("gaji-approve") &&
        !e.isEditing
      ) {
        if (e.rowElement.classList.contains("class-tandai-salah")) {
          e.rowElement.classList.remove("class-tandai-salah");
          e.cells.forEach((cell) => {
            cell.cellElement.classList.remove("class-tandai-salah");
          });

          this.tandaiSalah(e.data.id, false);
        } else {
          if (!e.data.status_gaji) {
            //explanation:
            // 1. e.rowElement.bgColor = "red";
            // 2. var cells = e.rowElement.cells; bisa tapi ada col yg ga bisa
            // cells[1].bgColor = "red";
            // cells[6].bgColor = "red";

            //3 e.columns[1].class = "class-tandai-salah"; ga bisa
            e.rowElement.classList.add("class-tandai-salah");
            e.cells.forEach((cell) => {
              cell.cellElement.classList.add("class-tandai-salah");
            });

            // 4 e.rowElement.classList.add("class-tandai-salah");

            this.tandaiSalah(e.data.id, true);
          }
        }
      }
    },

    async tandaiSalah(gajiId, tandaiSalah) {
      if (tandaiSalah) this.notif["salah"] += 1;
      else this.notif["salah"] -= 1;

      const updatedData = {
        tandai_salah: tandaiSalah,
      };
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      try {
        const response = await axios.put(
          `${API_BASE_URL}/gaji/${gajiId}`,
          updatedData,
          config
        );
        if (response.data.status) {
          // this.notif = await this.fetchDataNotif();
          // this.notif["salah"] = notifBaru;
        } else {
          notify("Gagal update gaji", "error");
        }
      } catch (error) {
        console.log(error);
        notify("Gagal update gaji", "error");
      }
    },

    async refreshNotif() {
      this.notif = await this.fetchDataNotif();
    },

    rowPrepared(e) {
      if (e.rowType === "data" && e.data) {
        if (e.data.tandai_salah) {
          e.rowElement.classList.add("class-tandai-salah");
          e.cells.forEach((cell) => {
            if ("cellElement" in cell) {
              cell.cellElement.classList.add("class-tandai-salah");
            }
          });
        }
      }
    },
    test(e) {
      console.log("test", e);
    },

    async approveClick(e) {
      if (!this.can("gaji-approve")) return 0;
      if (e.data.value) return 0; //gaji sudah diapprove

      if (await this.approveGaji(e.data.data.id)) {
        e.data.data.status_gaji = true;
        var rowElement = e.data.component.getRowElement(e.data.rowIndex);
        rowElement[0].classList.remove("class-tandai-salah");
        rowElement[1].classList.remove("class-tandai-salah");
        //ini kenapa ga bisa view row element, like i wanna cry for real
      }
    },

    async approveGaji(gajiId) {
      var notifBaru = this.notif["approved"];
      notifBaru += 1;
      var notifBaruSalah = this.notif["salah"];
      notifBaruSalah -= 1;
      if (notifBaruSalah < 0) notifBaruSalah = 0;

      const updatedData = {
        status_gaji: true,
        tandai_salah: false,
      };
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      try {
        const response = await axios.put(
          `${API_BASE_URL}/gaji/${gajiId}`,
          updatedData,
          config
        );
        if (response.data.status) {
          // this.notif = await this.fetchDataNotif();
          this.notif["approved"] = notifBaru;
          this.notif["salah"] = notifBaruSalah;
          return true;
        } else {
          notify("Gagal update gaji", "error");
          return false;
        }
      } catch (error) {
        console.log(error);
        notify("Gagal update gaji", "error");
        return false;
      }
    },
    buttonStatus(method) {
      var type = this.gajiStatusSource.find(
        (g) => g.id === this.gajiPeriodeData.gaji_status_id
      ).warna;
      var text = this.gajiStatusSource.find(
        (g) => g.id === this.gajiPeriodeData.gaji_status_id
      ).nama;

      if (method === "type") return type;
      else return text;
    },

    buttonCan(permiss) {
      if (this.gajiPeriodeData.gaji_status_id == 3) {
        //approved
        return false;
      }
      if (
        this.gajiPeriodeData.gaji_status_id == 1 ||
        this.gajiPeriodeData.gaji_status_id == 4
      ) {
        //open/revision
        if (this.can("gaji-approve") && permiss === "gaji-approve")
          return false;
        if (this.can("gaji-create") && permiss === "gaji-create") return true;
        if (this.can("gaji-update") && permiss === "gaji-update") return true;
        else return false;
      }

      if (this.gajiPeriodeData.gaji_status_id == 2) {
        //request approve

        if (this.can("gaji-approve") && permiss === "gaji-approve") return true;
        else return false;
      }

      return true;
    },
    async sinkronAllGaji(updatedData) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      await axios
        .post(`${API_BASE_URL}/sinkron_all_gaji`, updatedData, config)
        .then((response) => {
          if (response.data.status) {
            notify("Daftar gaji berhasil disinkron", "success");
            this.refreshAllGrid();
          } else {
            notify("Daftar gaji gagal disinkron", "error");
          }
        })
        .catch((error) => {
          console.log(error);
          notify("Daftar gaji gagal disinkron", "error");
        });
    },
    approveAllGajiAlert() {
      this.popupWarningVisible = true;
      this.popupWarningTitle = "Konfirmasi";
      this.popupWarningContent =
        "Anda yakin ingin melakukan Approve Semua Gaji? Gaji yang sudah di approve tidak dapat diubah.";
      //
      this.popupWarningStatusId = 3;
    },
    requestRevisionAlert() {
      this.popupWarningVisible = true;
      this.popupWarningTitle = "Konfirmasi";
      this.popupWarningContent =
        "Anda yakin ingin melakukan Request Revisi Gaji? Gaji akan dikembalikan kepada pegawai untuk direvisi.";
      this.popupWarningStatusId = 4;
    },
    requestApprovalAlert() {
      this.popupWarningVisible = true;
      this.popupWarningTitle = "Konfirmasi";
      this.popupWarningContent =
        "Anda yakin ingin melakukan Request Approval Gaji? Gaji akan diserahkan kepada Pejabat untuk diperiksa. Anda tidak dapat mengubah data selama proses pemeriksaan gaji berlangsung.";
      this.popupWarningStatusId = 2; //requestapprov
    },
    updateStatusGajiPeriode(statusBaru) {
      const updatedData = {
        gaji_status_id: statusBaru,
      };
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      axios
        .put(
          `${API_BASE_URL}/gajiPeriode/${this.gajiPeriodeId}`,
          updatedData,
          config
        )
        .then((response) => {
          if (response.data.status) {
            notify("Berhasil Update Status Penggajian", "success");
            const url = this.$router.resolve({
              name: "gaji-periode",
            }).href;

            window.location.href = url;
          } else {
            notify("Gagal Update Status Penggajian Gaji", "error");
          }
          // Handle success response
        })
        .catch((error) => {
          console.error("Error updating:", error);
          // Handle error
          notify("Gagal Update Status Penggajian Gaji", "error");
        });
    },
    async refreshAllGaji() {
      //1. ambil perubahan gajiPeriode terbaru OK
      //2. panggil axios refreshAllGaji
      //3. pass gajiPeriode terbaru ke axios
      // 4. update gajiPeriode berdasarkan data terbaru (lihat apakah update tgl berubah) OK
      //5. delete all gaji where gaji_periode_id = x ok
      //6. loading page ok
      //7. panggil lagi api untuk post gaji ok
      //8. return ke gajiperiode

      this.gajiPeriodeData.updated_by_user_id = auth.getUser().id;

      try {
        this.popupLoadingVisible = true;
        const response = await axios.post(
          `${API_BASE_URL}/refresh_all_gaji`,
          this.gajiPeriodeData,
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.status) {
          this.popupLoadingVisible = false;
          this.popupRefreshAllGajiVisible = false;
          notify("Berhasil Hitung Ulang Gaji Seluruh Pegawai", "success");
          window.location.reload();
        } else {
          this.popupLoadingVisible = false;
          this.popupRefreshAllGajiVisible = false;
          notify("Gagal Hitung Ulang Gaji Seluruh Pegawai", "error");
        }
      } catch (error) {
        this.popupLoadingVisible = false;
        this.popupRefreshAllGajiVisible = false;
        notify("Gagal Hitung Ulang Gaji Seluruh Pegawai", "error");
        console.error("Error update data:", error);
      }
    },
    async refreshGajiPerPegawai() {
      this.gajiPeriodeData.updated_by_user_id = auth.getUser().id;
      var data = {
        gaji_periode_id: this.gajiPeriodeData.id,
        pegawai_id: this.rowClickData.row.data.pegawai_id,
        gaji_id: this.rowClickData.row.data.id,
        edited_by_user_id: auth.getUser().id,
      };

      try {
        const response = await axios.post(
          `${API_BASE_URL}/generate_gaji_per_pegawai`,
          data,
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.status) {
          notify(response.data.message, "success");
          // window.location.reload();
        } else {
          notify(response.data.message, "error");
        }
      } catch (error) {
        notify("Gagal Hitung Ulang Gaji  Pegawai", "error");
        console.error("Error update data:", error);
      }
      this.$refs[this.rowClickRef].instance.refresh();
    },
    refreshGajiPerPegawaiConfirm(e, ref) {
      this.popupWarningVisible = true;
      this.popupWarningTitle =
        "Konfirmasi Hitung Ulang Gaji " + e.row.data.pegawai.nama;
      this.popupWarningContent =
        "Anda yakin ingin melakukan Hitung Ulang Gaji " +
        e.row.data.pegawai.nama +
        "? Perubahan data gaji yang Anda lakukan akan hilang.";
      this.popupWarningStatusId = "refreshGajiPerPegawaiConfirm";
      this.rowClickData = e;
      this.rowClickRef = ref;
    },
    refreshAllGajiConfirm() {
      this.popupWarningVisible = true;
      this.popupWarningTitle = "Konfirmasi Hitung Ulang Seluruh Gaji";
      this.popupWarningContent =
        "Anda yakin ingin melakukan Hitung Ulang Seluruh Gaji? Perubahan data gaji yang Anda lakukan akan hilang.";
      this.popupWarningStatusId = "refreshAllGajiConfirm";
    },
    async refreshAllGrid() {
      // this.$refs["gridRefTetap"].instance.getDataSource().reload();
      // this.$refs["gridRefTetap"].instance.getDataSource().reload();
      // this.$refs["gridRefHonor"].instance.getDataSource().reload();
      // this.$refs["gridRefKontrak"].instance.getDataSource().reload();
    },
    handleClickNotif(e) {
      if (e === "approved") {
        this.opacitySalah = 1;
        this.opacityApproved = 0.6;
        this.opacityJmlPegawai = 1;
        this.filterValue = ["status_gaji", "=", true];
      } else if (e === "salah") {
        this.opacitySalah = 0.6;
        this.opacityApproved = 1;
        this.opacityJmlPegawai = 1;
        this.filterValue = ["tandai_salah", "=", true];
      } else {
        this.filterValue = [];
        this.opacitySalah = 1;
        this.opacityApproved = 1;
        this.opacityJmlPegawai = 0.6;
      }
      this.refreshAllGrid();
    },
    async fetchDataNotif() {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/rangkuman_gaji_list`,
          this.gajiPeriodeId,
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "Content-Type": "application/json",
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchGaji(
      $gajiPeriodeId,
      $pegawaiStatusId,
      $pegawaiStatusIdAlt = null
    ) {
      var data = {
        gaji_periode_id: $gajiPeriodeId,
        pegawai_status_id: $pegawaiStatusId,
        pegawai_status_id_alt: $pegawaiStatusIdAlt,
      };
      try {
        const response = await axios.post(`${API_BASE_URL}/fetch_gaji`, data, {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "Content-Type": "application/json",
          },
        });
        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async fetchDataPeriode() {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/gajiPeriode/${this.gajiPeriodeId}`,
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "Content-Type": "application/json",
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    calculateCellMK(e) {
      //TODO nyari masa kerja bukan dari tgl sekarang, melainkan tgl pembuatan gaji
      const today = DateTime.fromISO(e.tgl_gaji);
      const tglMulaiKerja = DateTime.fromISO(e.pegawai.tgl_mulai_bekerja);

      const month = tglMulaiKerja.month + 1; // Months are zero-based, so add 1
      const year = tglMulaiKerja.year;

      var tglMk;
      if ((month >= 11 && month <= 12) || (month >= 1 && month <= 4)) {
        // If the month is between November and April (inclusive), set the date to April 1st
        tglMk = DateTime.fromObject({ year: year, month: 4, day: 1 });
      } else if (month >= 3 && month <= 10) {
        // If the month is between March and October (inclusive), set the date to October 1st
        tglMk = DateTime.fromObject({ year: year, month: 10, day: 1 });
      } else {
        // Handle other cases as needed
        tglMk = tglMulaiKerja;
      }
      return Math.floor(today.diff(tglMk, "years").years);
    },

    can,
    refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
    },
    detailPegawai(e) {
      // this.$router.push({
      //   name: "simpeg-pegawai-detail",
      //   query: { id: e.row.data.pegawai_id },
      // });
      const url = this.$router.resolve({
        name: "simpeg-pegawai-detail",
        query: { id: e.row.data.pegawai_id },
      }).href;
      window.open(url, "_blank");
    },
    detailAbsen(e) {
      const url = this.$router.resolve({
        name: "absen-list",
        query: {
          filter: ["pegawai_id", "=", e.row.data.pegawai_id],
          filterPeriode: ["periode_absen", "=", e.row.data.gajiPeriode.tgl],
        },
      }).href;
      window.open(url, "_blank");
    },
    async updateKetGaji(gajiId, data) {
      try {
        const updatedData = {
          ket: data,
        };
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };
        const response = await axios.put(
          `${API_BASE_URL}/gaji/${gajiId}`,
          updatedData,
          config
        );

        if (response.data.status) {
          notify("Berhasil Update Gaji", "success");
          return response.data;
        } else {
          notify("Gagal update gaji (ket: " + data + ")", "error");
          return response.data;
        }
      } catch (error) {
        // Handle the error appropriately
        console.error("Error:", error);
        notify("Gagal update gaji " + error, "error");
        return false; // If there was an error
      }
    },
    async onRowUpdating(e) {
      var length = Object.keys(e.newData).length;
      if (length == 1 && "ket" in e.newData) {
        //pakai odataa
      } else {
        e.cancel = true;
        await this.hitungUlangFieldGaji(e.key, e.newData, e.oldData);

        e.component.cancelEditData();

        e.component.refresh();
      }
      if (!("ket" in e.newData)) {
        //field catatan/ket bisa diupdate melalui odata biasa tnapa harus hitung ulang gaji
        //selain itu, setelah update row harus calculate ulang field lain yang rumusnya berkaitan dengan currenteditingfield
        //call hitung_ulang_field_gaji
        //harus di cancel true dulu karena menunggu calculate ulang, setelah await sudah selesai
        //baru refresh component
      }

      return;
    },

    async hitungUlangFieldGaji(key, newData, oldData) {
      try {
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };
        var data = {
          id: key,
          pegawai_id: oldData.pegawai_id,
          tgl_gaji: oldData.tgl_gaji,
          absen_bulan_id: oldData.absen_bulan_id,
          changes: newData,
          proyeksi: false,
          edited_by_user_id: auth.getUser().id,
        };
        const response = await axios.post(
          `${API_BASE_URL}/refresh_gaji_per_pegawai`,
          data,
          config
        );
        // You can access the response data using response.data
        if (response.data.status) {
          notify(response.data.message, "success");
          return response.data;
        } else {
          notify("Gagal update gaji pegawai", "error");
          return response.data;
        }
        // You can perform other operations here based on the response data
        // ...
      } catch (error) {
        // Handle the error appropriately
        console.error("Error:", error);
        notify("Gagal update gaji pegawai " + error, "error");
        return false; // If there was an error
      }
    },

    async saveEditedDataToOData(key, newData, oldData) {
      try {
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };
        var data = {
          id: key,
          pegawai_id: oldData.pegawai_id,
          tgl_gaji: oldData.tgl_gaji,
          absen_bulan_id: oldData.absen_bulan_id,
          changes: newData,
          proyeksi: false,
        };
        const response = await axios.post(
          `${API_BASE_URL}/refresh_gaji_per_pegawai`,
          data,
          config
        );
        // You can access the response data using response.data
        if (response.data.status) {
          notify(response.data.message, "success");
          return response.data;
        } else {
          notify("Gagal update gaji pegawai", "error");
          return response.data;
        }
        // You can perform other operations here based on the response data
        // ...
      } catch (error) {
        // Handle the error appropriately
        console.error("Error:", error);
        notify("Gagal update gaji pegawai " + error, "error");
        return false; // If there was an error
      }
    },

    async saveEditedDataToOData2(key, newData, oldData) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      var data = {
        id: key,
        pegawai_id: oldData.pegawai_id,
        tgl_gaji: oldData.tgl_gaji,
        absen_bulan_id: oldData.absen_bulan_id,
        changes: newData,
      };

      return await axios
        .post(`${API_BASE_URL}/refresh_gaji_per_pegawai`, data, config)
        .then((response) => {
          notify(response.data.message, "success");
        })
        .catch((error) => {
          console.log(error);
          notify("gagal update gaji", "error");
        });
    },
    oneditorpreparing: function (e) {
      if (e.parentType === "dataRow") {
        if (e.row.data.status_gaji) e.editorOptions.disabled = true;
        else {
          if (e.class == "noteditable") e.editorOptions.disabled = true;
          else if (e.class == "noteditable-gaji" && this.can("gaji-update"))
            e.editorOptions.disabled = false;
          else if (e.class == "noteditable-gaji" && !this.can("gaji-update"))
            e.editorOptions.disabled = true;
          else if (e.class == "noteditable-ket" && this.can("gaji-approve"))
            e.editorOptions.disabled = false;
          else if (e.class == "noteditable-ket" && !this.can("gaji-approve"))
            e.editorOptions.disabled = true;
        }
      }

      if (e.dataField === "tgl_gaji") {
        e.editorOptions.calendarOptions = {
          minZoomLevel: "year",
          maxZoomLevel: "year",
          displayFormat: "MM/yyyy",
          type: "month",
        };
      }
    },

    async approveAll(tab) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      var data = {};

      if (tab == "tDireksi") {
        data = {
          pegawai_status_id: 1,
          pegawai_status_nama: "Direksi",
        };
      } else if (tab == "tTetap") {
        data = {
          pegawai_status_id: 2,
          pegawai_status_nama: "Pegawai Tetap",
        };
      } else if (tab == "tHonor") {
        data = {
          pegawai_status_id: 3,
          pegawai_status_nama: "Pekerja Honor",
        };
      } else if (tab == "tKontrak") {
        data = {
          pegawai_status_id: 4,
          pegawai_status_nama: "Pekerja Kontrak",
        };
      }

      await axios
        .post(`${API_BASE_URL}/gaji_approve_all`, data, config)
        .then((response) => {
          notify(response.data.message, "success");
          if (tab == "tDireksi") this.dataSourceDireksi.reload();
          if (tab == "tTetap") this.dataSourceTetap.reload();
          if (tab == "tHonor") this.dataSourceHonor.reload();
          if (tab == "tKontrak") this.dataSourceKontrak.reload();
        })
        .catch((error) => {
          console.log(error);
          notify("Gagal approve gaji", "error");
        });
    },

    async approveGaji2(gajiId) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "multipart/form-data",
        },
      };
      var data = {
        id: gajiId,
      };

      axios
        .post(`${API_BASE_URL}/gaji_approve`, data, config)
        .then((response) => {
          notify(response.data.message, "success");
          return true;
        })
        .catch((error) => {
          notify("Gagal approve gaji", "error");
          console.log(error);
          return false;
        });
    },
    formatStatusGaji(method, value) {
      if (value.data.data.status_gaji) {
        if (method == "icon") return "lock";
        if (method == "type") return "success";
      } else {
        if (method == "icon") return "warning";
        if (method == "type") return "danger";
      }
      return;
    },

    formatNumber(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return value;
    },
    calculateDisplayMK(e) {
      const today = DateTime.fromISO(e.tgl_gaji);
      const date2 = DateTime.fromISO(e.riwayatGolongan.tgl_mulai_bekerja);

      return Math.floor(today.diff(date2, "years").years) + " tahun";
    },
    formatMasaKerja(e) {
      const today = DateTime.local().setLocale("id"); //TODO nyari masa kerja bukan dari tgl sekarang, melainkan tgl pembuatan gaji
      const date2 = DateTime.fromISO(e);

      return Math.floor(today.diff(date2, "years").years);
    },
    formatMonthTitle(e) {
      const date = DateTime.fromISO(e).setLocale("id");

      return date.monthLong + " " + date.year;
    },
    formatMonth(e) {
      const isoDateString = e.split("/").reverse().join("-") + "-01";

      const date = DateTime.fromISO(isoDateString).setLocale("id");

      return date.monthLong + " " + date.year;
    },
    onPageChanged(e, gridRef) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs[gridRef].instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Gaji");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Gaji " + this.tabSource[this.tabPanelIndex].text + ".xlsx"
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
